import React, {useEffect, useState} from 'react';
import * as CandidateService from '@app/services/CandidateService';
import {searchAllInputInfo} from '@app/services/CandidateService';
import {toast} from 'react-toastify';
import * as ExtractService from '@app/services/ExtractService';
import {requestDownloadCV} from '@app/services/ExtractService';
import {Document, Page, pdfjs} from 'react-pdf';
import '../styles.css';
import {cloneDeep} from 'lodash';
import {Checkbox} from '@components';
import Select from 'react-select';
import {AREA_OPTIONS, Provinces} from '@app/constants/Provinces';
import * as ValidateUtils from '@app/utils/ValidationUtils';
import {autoCorrectStrPhone} from '@app/utils/ValidationUtils';
import {
    CANDIDATE_CATEGORY_FIELDS,
    CANDIDATE_INPUT_INFO_TYPES,
    CANDIDATE_ORIGINS_OPTIONS,
    ExtractType,
    GENDERS,
    INDUSTRY_FUNCTIONS,
    LATEST_STABLE_LEVELS,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ME_LIST_INPUT,
    OBJECT_SPECIALS, PersonTypeOptions,
    ResponseCode,
    STANDARD_SEARCH_IGNORE_OPTIONS
} from '@app/constants/Common';
import {
    appendArrayValues,
    appendOptions,
    arrayIncludeItem,
    arrayToLowerCase,
    arrayToString,
    checkEmailToSendInOtherEmails,
    compareArrays,
    compareOptions,
    compareString,
    exportCandidatesExcel,
    monthOptions,
    optionsToArray,
    stringToArray, stringToLowerCase,
    twoArrayHaveSameElement,
    yearOptions
} from '@app/utils/CommonUtils';
import {Link} from 'react-router-dom';
import ReactChipInput from 'react-chip-input';
import CandidateFlows from "@pages/candidate/userinput/component/CandidateFlows";

import "react-datepicker/dist/react-datepicker.css";
import {standardPrefixPhones} from "@app/utils/PhoneUtils";
import {alertMessage, Messages, showMessage} from "@app/constants/Messages";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import * as CandidateUtils from "@app/utils/CandidateUtils";
import {checkExistsCommonFieldValues, confirmSubmitNotesWhenInputInPriorityTimeRange} from "@app/utils/CandidateUtils";
import {COUNTRIES, CANDIDATE_NATIONALITIES, checkNationalOptionsHaveExpatAndVN} from "@app/constants/Nationality";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";
import CandidateLanguageComponent from "@pages/candidate/commonview/language/CandidateLanguageComponent";
import DobInputGroup from "@pages/candidate/detail/DobInputGroup";
import { validateDMYInput } from "@pages/dvtjcuv/common/ValidateUtils";

const ProcessExtractResult = (props) => {
    const [candidates, setCandidates] = useState([]);
    const [extractCandidates, setExtractCandidates] = useState([]);
    const [checkingExistsLoading, setCheckingExistsLoading] = useState(false);
    const [currCandidate, setCurrCandidate] = useState({origin_extract_result: {}});
    const [currentIndex, setCurrentIndex] = useState(0);
    const [exportExcelFlg, setExportExcelFlg] = useState(false);
    const [failedCVs, setFailedCVs] = useState([]);
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [standardPersonalEmails, setStandardPersonalEmails] = useState([]);
    const [workYears, setWorkYears] = useState([]);
    const [workMonths, setWorkMonths] = useState([]);
    const [showContent, setShowContent] = useState(false);
    const [createCandidateFormInputSuccess, setCreateCandidateFormInputSuccess] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [inputCommonData, setInputCommonData] = useState({
        common_industry: '',
        common_function: '',
        common_origin: '',
        common_origin_note: '',
        common_general_note: '',
        hasSaveInputCommon: false,
    });
    const [showCommonInputModal, setShowCommonInputModal] = useState(false);
    const [btnInputCommonData, setBtnInputCommonData] = useState(false);

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    const {candidateList, cvFailedList, isExportExcel, refererInfo, hasInputCommon, isShow, isFormInput, onFinishCheckExists} = props
    useEffect(() => {
        console.log('useEffect');
        if (hasInputCommon && btnInputCommonData && !showCommonInputModal && candidates.length > 0) {
            setShowCommonInputModal(true);
            btnInputCommonData.click();
        }

        if (provinceOptions.length === 0) {
            let provinces = [];
            Provinces.forEach(item => {
                provinces.push({
                    value: item,
                    label: item.charAt(0).toUpperCase() + item.slice(1)
                });
            });
            setProvinceOptions(provinces);
        }

        if (workYears.length === 0) {
            setWorkYears(yearOptions());
        }

        if (workMonths.length === 0) {
            setWorkMonths(monthOptions());
        }

    }, [isFormInput]);

    useEffect(async () => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        setFailedCVs([...cvFailedList])
        setExtractCandidates(cloneDeep(candidateList));
        setCandidates(cloneDeep(candidateList));
        if (candidateList.length === 1) {
            setCurrentIndex(0)
            setCurrCandidate(cloneDeep(candidateList[0]));
            requestDownloadCV(candidateList[0].origin_cv).then(url => {
                candidateList[0].cv_display_url = url
                setCurrCandidate(cloneDeep(candidateList[0]));
            })
        }
    },[candidateList, cvFailedList]);

    useEffect(() => {
        setExportExcelFlg(isExportExcel)
    },[isExportExcel]);

    useEffect(() => {
        setShowContent(isShow)
    },[isShow]);

    const PROCESS_FIELDS = ['full_name', 'last_name', 'vn_name', 'foreign_name',
        'email_name', 'email', 'phone', 'gender', 'vocative',
        'caller_name_to_email', 'local_province', 'local_area', 'local_province_email', 'local_area_email',
        'industry', 'industry_segment1', 'industry_segment2', 'function', 'function_segment1', 'function_segment2', 'industry_function', 'latest_stable_level'];

    const openNewTab = async (url) => {
        if (url.indexOf('https') === -1) {
            url = `https://${url}`;
            window.open(url, '_blank').focus();
        }
        return false;
    };

    const onRemoveCandidate = () => {
        let canList = cloneDeep(candidates);
        canList.splice(currentIndex, 1);
        setCandidates(canList);
        let nextIndex = currentIndex
        if (currentIndex > canList.length - 1) {
            nextIndex = canList.length - 1
            setCurrentIndex(nextIndex);
        }

        setCurrCandidate(cloneDeep(canList[nextIndex]));
        requestDownloadCV(canList[nextIndex].origin_cv).then(url => {
            canList[nextIndex].cv_display_url = url
            setCurrCandidate(cloneDeep(canList[nextIndex]));
        })
    };

    const validateInputEmail = (emails) => {
        if (emails && !ValidateUtils.validateEmailString(emails, ';')) {
            alert('Email nhập không hợp lệ!');
            return false;
        }
        return true;
    };

    const validateInputPhone = (phone) => {
        if (phone && !ValidateUtils.validatePhoneString(phone, ';')) {
            alert('Số điện thoại nhập không hợp lệ!');
            return false;
        }
        return true;
    };

    const onExportExcel = () => {
        // Validate email
        if (!validateInputEmail(currCandidate.email)) {
            return;
        }

        // Validate phone
        if (!validateInputPhone(currCandidate.phone)) {
            return;
        }

        exportCandidatesExcel(candidates)

    };

    const onCandidateNext = () => {
        // Validate email
        if (!validateInputEmail(currCandidate.email)) {
            return;
        }

        // Validate phone
        if (!validateInputPhone(currCandidate.phone)) {
            return;
        }
        let nextIndex = currentIndex + 1;
        setCurrentIndex(nextIndex);
        setCurrCandidate(cloneDeep(candidates[nextIndex]));
        requestDownloadCV(candidates[nextIndex].origin_cv).then(url => {
            candidates[nextIndex].cv_display_url = url
            setCurrCandidate(cloneDeep(candidates[nextIndex]));
        })
    };


    const onCandidateBack = () => {
        // Validate email
        if (!validateInputEmail(currCandidate.email)) {
            return;
        }

        // Validate phone
        if (!validateInputPhone(currCandidate.phone)) {
            return;
        }
        let nextIndex = currentIndex - 1;
        setCurrentIndex(nextIndex);
        setCurrCandidate(cloneDeep(candidates[nextIndex]));
        requestDownloadCV(candidates[nextIndex].origin_cv).then(url => {
            candidates[nextIndex].cv_display_url = url
            setCurrCandidate(cloneDeep(candidates[nextIndex]));
        })
    };

    const onChangeLocalProvince = (values) => {
        candidates[currentIndex]['local_province'] = values;
        currCandidate['local_province'] = values;
        candidates[currentIndex]['local_province_email'] = values;
        currCandidate['local_province_email'] = values;
        setCandidates(cloneDeep(candidates));
    };
    const onChangeLocalNationality = (values) => {
        if (checkNationalOptionsHaveExpatAndVN(values)) {
            showMessage(Messages.cannotNationalExpatAndVN)
            return;
        }
        candidates[currentIndex]['local_nationality'] = values;
        currCandidate['local_nationality'] = values;
        setCandidates(cloneDeep(candidates));
    };
    const onChangeLocalEverWorkNationality = (values) => {
        candidates[currentIndex]['local_ever_work_nationality'] = values;
        currCandidate['local_ever_work_nationality'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onChangeLocalProvinceEmail = (values) => {
        candidates[currentIndex]['local_province_email'] = values;
        currCandidate['local_province_email'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onChangeLanguages = (values) => {
        console.log("onChangeLanguages")
        candidates[currentIndex].languages = values;
        currCandidate.languages = values;
    };

    const onChangeLocalArea = (values) => {
        candidates[currentIndex]['local_area'] = values;
        currCandidate['local_area'] = values;
        candidates[currentIndex]['local_area_email'] = values;
        currCandidate['local_area_email'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onChangeLocalAreaEmail = (values) => {
        candidates[currentIndex]['local_area_email'] = values;
        currCandidate['local_area_email'] = values;
        setCandidates(cloneDeep(candidates));
    };

    const onRemoveSpace = (fieldName, careerIndex) => {
        if (['email', 'email_to_send', 'phone', 'full_name', 'origin_company', 'title'].includes(fieldName)) {
            // Trường hợp là các field trong career summaries
            if (careerIndex !== undefined && careerIndex !== "") {
                let fieldValue = currCandidate.career_summaries[careerIndex][fieldName]
                if (fieldValue) {
                    fieldValue = fieldValue.replaceAll(" ", "")
                    currCandidate.career_summaries[careerIndex][fieldName] = fieldValue;
                    setCurrCandidate({...currCandidate});
                    candidates[currentIndex].career_summaries = currCandidate.career_summaries;
                }

            } else {
                let fieldValue = currCandidate[fieldName]
                if (fieldValue) {
                    fieldValue = fieldValue.replaceAll(" ", "")
                    currCandidate[fieldName] = fieldValue
                    candidates[currentIndex][fieldName] = fieldValue;
                    setCurrCandidate({...currCandidate})
                }
            }
        }
    };


    const onChangeInput = (event, fieldKey) => {
        console.log('onChangeInput');
        if (fieldKey === 'industry_function') {
            candidates[currentIndex]['industry_function'] = event;
            currCandidate['industry_function'] = event;
            setCandidates(cloneDeep(candidates));
            currCandidate[fieldKey] = event;
            return;
        }

        let fieldName = event.target.name;
        let fieldValue = event.target.value;
        candidates[currentIndex][fieldName] = fieldValue;
        currCandidate[fieldName] = fieldValue;
        if (fieldName === 'gender') {
            //
            if (fieldValue === 'nam') {
                candidates[currentIndex]['caller_name_to_email'] = 'anh';
                currCandidate['caller_name_to_email'] = 'anh';
            } else if (fieldValue === 'nữ') {
                candidates[currentIndex]['caller_name_to_email'] = 'chị';
                currCandidate['caller_name_to_email'] = 'chị';
            } else {
                candidates[currentIndex]['caller_name_to_email'] = '';
                currCandidate['caller_name_to_email'] = '';
            }
        } else if (fieldName === 'vn_name') {
            if (fieldValue) {
                candidates[currentIndex]['email_name'] = fieldValue;
                currCandidate['email_name'] = fieldValue;
            } else {
                candidates[currentIndex]['email_name'] = currCandidate['foreign_name'];
                currCandidate['email_name'] = currCandidate['foreign_name'];
            }
        } else if (fieldName === 'foreign_name') {
            if (!currCandidate['vn_name']) {
                candidates[currentIndex]['email_name'] = fieldValue;
                currCandidate['email_name'] = fieldValue;
            }
        } else if (fieldName === 'local_province') {
            candidates[currentIndex]['local_province_email'] = fieldValue;
            currCandidate['local_province_email'] = fieldValue;
        } else if (fieldName === 'local_area') {
            candidates[currentIndex]['local_area_email'] = fieldValue;
            currCandidate['local_area_email'] = fieldValue;
        } else if (fieldName === 'phone') {
            fieldValue = autoCorrectStrPhone(fieldValue, ";")
            fieldValue = standardPrefixPhones(fieldValue)
            candidates[currentIndex]['phone'] = fieldValue;
            currCandidate['phone'] = fieldValue;
        } else if (fieldName === 'email') {
            fieldValue = fieldValue.replaceAll(" ", "")
            candidates[currentIndex]['email'] = fieldValue;
            currCandidate['email'] = fieldValue;
        }

        setCurrCandidate({...currCandidate})
        setCandidates(cloneDeep(candidates));

    };

    const checkEmailToSendInErrorBlockEmail = () => {
        const arrEmailToSend = stringToArray(currCandidate.email_to_send)
        if (arrEmailToSend) {
            const arrOtherEmail = [
                ...stringToArray(currCandidate.db_rarely_email),
                ...stringToArray(currCandidate.db_ever_email),
                ...stringToArray(currCandidate.db_block_email),]
            if (twoArrayHaveSameElement(arrEmailToSend, arrOtherEmail)) {
                return <span className={'text-danger w-100 mb-2'}>
                    {Messages.emailToSendInErrorBlockEmails}
            </span>
            }
        }
        return ""
    }

    const checkEmailToSendInAllEmail = () => {
        const arrEmailToSend = stringToArray(currCandidate.email_to_send)
        if (arrEmailToSend && arrEmailToSend.length > 0) {
            let arrOtherEmail = [
                ...stringToArray(currCandidate.db_rarely_email),
                ...stringToArray(currCandidate.db_ever_email),
                ...stringToArray(currCandidate.db_block_email),
                ...stringToArray(currCandidate.db_email),
                ...stringToArray(currCandidate.db_email_to_send)]
            if (!checkEmailToSendInOtherEmails(arrEmailToSend, arrOtherEmail)) {
                return <span className={'text-danger w-100 mb-2'}>
                    {Messages.emailToSendNotInAllEmails}
            </span>
            }
        }

        return ""
    }

    const onAddIndustryFunctionItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(currCandidate[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            currCandidate[fieldName] = arr
            candidates[currentIndex][fieldName] = arr;
            setCurrCandidate({...currCandidate})
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveIndustryFunctionItem = (index, fieldName) => {
        let arr = cloneDeep(currCandidate[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            currCandidate[fieldName] = arr
            candidates[currentIndex][fieldName] = arr;
            setCurrCandidate({...currCandidate})
        }
    }

    const onChangeIndustryFunctionItem = (event, fieldName) => {
        if (fieldName === 'industry_function') {
            currCandidate[fieldName] = event
            candidates[currentIndex][fieldName] = event;
        } else {
            currCandidate[event.target.name] = event.target.value
            candidates[currentIndex][event.target.name] = event.target.value;
        }
        setCurrCandidate(cloneDeep(currCandidate))
    }

    const onChangeCommonInput = (event, fieldName) => {
        console.log('onChangeCommonInput');
        if (fieldName === 'common_industry' || fieldName === 'common_function') {
            let arr = cloneDeep(inputCommonData[fieldName])
            if (!arr) {
                arr = []
            }
            if (!arrayIncludeItem(arr, event)) {
                arr.push(event)
                inputCommonData[fieldName] = arr
            } else {
                alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
            }
        } else if (fieldName === 'common_industry_function' || fieldName === 'common_object_special'
            || fieldName === 'common_local_nationality'|| fieldName === 'common_origin') {
            // Trường hợp field là quốc tịch và chọn cả VN lẫn Expat => báo lỗi
            if (fieldName === 'common_local_nationality' && checkNationalOptionsHaveExpatAndVN(event)) {
                showMessage(Messages.cannotNationalExpatAndVN)
                return;
            }
            inputCommonData[fieldName] = event;
        } else {
            inputCommonData[event.target.name] = event.target.value;
        }

        setInputCommonData(cloneDeep(inputCommonData));
    };

    const onRemoveCommonIndustryFunctionItem = (index, fieldName) => {
        if (fieldName === 'common_industry' || fieldName === 'common_function') {
            let arr = cloneDeep(inputCommonData[fieldName])
            if (arr && arr.length > 0) {
                if (arr.length === 1) {
                    arr = []
                } else {
                    arr.splice(index, 1);
                }
                inputCommonData[fieldName] = arr
                setInputCommonData({...inputCommonData})
            }
        }
    }

    const saveCommonFields = (can, commonData) => {
        can.industry = appendArrayValues(can.industry, commonData.common_industry);
        can.industry_function = appendArrayValues(can.industry_function, commonData.common_industry_function);
        can.function = appendArrayValues(can.function, commonData.common_function);
        can.local_nationality = appendOptions(can.local_nationality, commonData.common_local_nationality);
        can.origin = commonData.common_origin ? commonData.common_origin : can.origin;
        can.origin_note = commonData.common_origin_note ? commonData.common_origin_note : can.origin_note;
        can.general_note = commonData.common_general_note ? commonData.common_general_note : can.general_note;
        can.candidate_know_state = commonData.candidate_know_state ? commonData.candidate_know_state : can.candidate_know_state;
        can.object_special = commonData.common_object_special ? commonData.common_object_special : can.object_special;
        can.standard_search_ignore = commonData.standard_search_ignore ? commonData.standard_search_ignore : can.standard_search_ignore;
        can.input_me_list = commonData.input_me_list ? commonData.input_me_list : can.input_me_list;
        can.block_state = commonData.block_state ? commonData.block_state : can.block_state;
        can.candidate_type = commonData.candidate_type ? commonData.candidate_type : can.candidate_type;
        can.flow_note = commonData.flow_note ? commonData.flow_note : can.flow_note;
        can.show_hide_state = commonData.show_hide_state ? commonData.show_hide_state : can.show_hide_state;
        return can
    }

    const onSaveCommonData = () => {
        console.log('onSaveCommonData');
        inputCommonData.hasSaveInputCommon = true
        let cans = candidates.map(can => {
            saveCommonFields(can, inputCommonData)
            return can;
        });

        saveCommonFields(currCandidate, inputCommonData)
        setCurrCandidate(cloneDeep(currCandidate));
        setCandidates(cloneDeep(cans));
    };

    const onAddCareerSummary = (event) => {
        console.log('onAddCareerSummary');
        if (!currCandidate.career_summaries) {
            currCandidate.career_summaries = []
        }

        if (currCandidate.career_summaries.length > 0) {
            let latestRow = currCandidate.career_summaries[currCandidate.career_summaries.length-1]

            let rowIsBlank = true
            Object.keys(latestRow).forEach(key => {
                if (key !== 'displayed_flag' && key !== 'created_user' && latestRow[key]) {
                    rowIsBlank = false
                }
            })

            if (rowIsBlank) {
                alert("Tồn tại record career summary chưa được nhập thông tin.")
                return;
            }
        }
        currCandidate.career_summaries.push({
            work_start_year: '',
            work_start_month: '',
            work_end_year: '',
            work_end_month: '',
            origin_company: '',
            title: '',
            company_note: '',
            note_of_period: '',
            displayed_flag: currCandidate.career_summaries.length === 0,
            created_user: userLoginInfo.id
        });

        setCurrCandidate({...currCandidate});
    };
    const onSortCareerSummary = () => {
        if (!currCandidate.career_summaries) {
            return;
        }
        currCandidate.career_summaries.sort(function(a, b) {
            if (a.work_start_year.value < b.work_start_year.value) {
                return 1;
            }
            if (a.work_start_year.value > b.work_start_year.value) {
                return -1;
            }

            if (a.work_start_month.value < b.work_start_month.value) {
                return 1;
            }
            if (a.work_start_month.value > b.work_start_month.value) {
                return -1;
            }
            return 0;
        });

        setCurrCandidate({...currCandidate});
    };
    const onDeleteCareerSummary = (index) => {
        if (currCandidate.career_summaries.length === 1) {
            currCandidate.career_summaries = [];
        } else {
            currCandidate.career_summaries.splice(index, 1);
        }

        setCurrCandidate({...currCandidate});
        candidates[currentIndex].career_summaries = currCandidate.career_summaries;
    };

    const onChangeCareerInput = (event, index) => {
        console.log('onChangeCommonInput');
        let fieldName = event.target.name
        if (fieldName === 'displayed_flag') {
            currCandidate.career_summaries.map(item => {
                item.displayed_flag = false
                return item;
            })
            currCandidate.career_summaries[index]["displayed_flag"] = true
        } else {
            currCandidate.career_summaries[index][fieldName] = event.target.value;
        }

        setCurrCandidate({...currCandidate});
        candidates[currentIndex].career_summaries = currCandidate.career_summaries;
    };

    const onChangeWorkTime = (index, value, fieldName) => {
        console.log('onChangeWorkTime');
        // Validate require end time >= start time
        let currentRow = currCandidate.career_summaries[index];
        let oldValue = currentRow[fieldName];
        //set new value temp
        currentRow[fieldName] = value;
        if (currentRow.work_start_year.value && currentRow.work_end_year.value && currentRow.work_start_year.value > currentRow.work_end_year.value
            || (currentRow.work_start_year.value === currentRow.work_end_year.value
                && currentRow.work_start_month.value > currentRow.work_end_month.value)) {
            currentRow[fieldName] = oldValue;
            alert('Time kết thúc phải sau Time bắt đầu.');
            return;
        }
        currCandidate.career_summaries[index][fieldName] = value;
        setCurrCandidate({...currCandidate});
        candidates[currentIndex].career_summaries = currCandidate.career_summaries;
    };


    const onAddReferCheck = (event) => {
        console.log('onAddReferCheck');
        if (!currCandidate.refer_checks) {
            currCandidate.refer_checks = [];
        }

        if (currCandidate.refer_checks.length > 0 && !currCandidate.refer_checks[currCandidate.refer_checks.length-1]) {
            return;
        }

        currCandidate.refer_checks.push(
            {
                candidate_cv_id: currCandidate.candidate_cv.id,
                content: ''
            }
        );

        setCurrCandidate({...currCandidate});
    };

    const onDeleteReferCheck = (index) => {
        console.log('onDeleteReferCheck');
        if (currCandidate.refer_checks.length === 1) {
            currCandidate.refer_checks = [];
        } else {
            currCandidate.refer_checks.splice(index, 1);
        }
        setCurrCandidate({...currCandidate});
        candidates[currentIndex].refer_checks = currCandidate.refer_checks;
    };

    const onProcessReferCheck = (index) => {
        console.log('onProcessReferCheck');
        ExtractService.processReferCheck({candidate_id: currCandidate.id, refer_check: currCandidate.refer_checks[index]}).then((res) => {
            console.log(JSON.stringify(res))
            if (res.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Xử lý nội dung refer check thành công.`);
                // setCurrCandidate({...currCandidate});
                // let canList = cloneDeep(candidates)
                // canList.push(res.content)
                // setCandidates(canList)
                // extractCandidates.push(res.content)
                props.onProcessRefCheckResult(res.content)
                currCandidate.refer_checks[index] = res.content.refer_check
                setCurrCandidate({...currCandidate})
            } else {
                toast.error(res.message);
                alert(res.message)
            }
        }).catch((error) => {
            // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    const onChangeReferCheckInput = (event, index) => {
        console.log('onChangeReferCheckInput');
        currCandidate.refer_checks[index].content = event.target.value;
        setCurrCandidate({...currCandidate});
        candidates[currentIndex].refer_checks = currCandidate.refer_checks;
    };

    const onRemoveSpaceReferCheckContent = (index) => {
        console.log('onRemoveSpaceReferCheckContent');
        let referCheck = currCandidate.refer_checks[index];
        referCheck.content = referCheck.content.replaceAll(" ", "");
        setCurrCandidate({...currCandidate});
        candidates[currentIndex].refer_checks = currCandidate.refer_checks;
    };

    const onLoadSuccess = async (pdfInfo) => {
        let currCan = {...currCandidate};
        currCan.numPages = [];
        for (let i = 1; i <= pdfInfo.numPages; i++) {
            currCan.numPages.push(i);
        }
        setCurrCandidate(currCan);
    };

    const onUpdateExtractResult = async (candidate, fields) => {
        // in case save all
        if (!fields) {
            // Validate email
            if (!validateInputEmail(currCandidate.email)) {
                return;
            }

            // Validate phone
            if (!validateInputPhone(currCandidate.phone)) {
                return;
            }

            if (!validateDMYInput(currCandidate.paper_dob, currCandidate.paper_mob, currCandidate.paper_yob)) {
                alert(`DOB giấy tờ không hợp lệ.`);
                return;
            }
        }

        // Bỏ đi theo yêu cầu mới sheet 21.8
        // if (currCandidate.require_email && !currCandidate.email) {
        //     alert(`Vui lòng nhập email.`);
        //     return;
        // }
        //
        // if (currCandidate.require_phone && !currCandidate.phone) {
        //     alert(`Vui lòng nhập số điện thoại.`);
        //     return;
        // }

        const arrOtherEmail = [
            ...stringToArray(currCandidate.db_rarely_email),
            ...stringToArray(currCandidate.db_ever_email),
            ...stringToArray(currCandidate.db_block_email)]
        if (twoArrayHaveSameElement(stringToArray(currCandidate.email_to_send), arrOtherEmail)) {
            toast.error(Messages.emailToSendInErrorBlockEmails);
            alert(Messages.emailToSendInErrorBlockEmails);
            return;
        }

        candidate.fields = [];
        if (fields) {
            candidate.fields = fields;
        }

        if (!candidate.savedFields) {
            candidate.savedFields = [];
        }

        if (candidate.fields.includes("email")) {
            // Check standard personal emails. Nếu user xác nhận ok sẽ tiếp tục xử lý tiếp theo.
            const confirm = await CandidateUtils.processWithoutPersonalEmail(stringToArray(currCandidate.email))
            if (!confirm) {
                return;
            }
        }

        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        if (checkExistsCommonFieldValues(candidate, userLoginInfo.id)
            || checkExistsCommonFieldValues(candidate.languages, userLoginInfo.id)) {
            return;
        }

        if (fields && fields.includes('paper_dob')) {
            if (!validateDMYInput(currCandidate.paper_dob, currCandidate.paper_mob, currCandidate.paper_yob)) {
                alert(`DOB giấy tờ không hợp lệ.`);
                return;
            }
        }

        let payload = candidate

        // Truong hop update 1 hoặc nhiều fields
        if (fields && fields.length > 0) {
            payload = {id: candidate.id}
            fields.forEach(f => {
                payload[f] = candidate[f]
            })
        }
        // if (fields && fields.length === 1) {
        //     payload = {id: candidate.id}
        //     payload[fields[0]] = candidate[fields[0]]
        // } else {
        //     onSortCareerSummary()
        // }

        // candidate.fields.forEach(field => {
        //     if (!candidate.savedFields.includes(field)) {
        //         candidate.savedFields.push(field);
        //     }
        // });

        if (isFormInput) {
            payload.is_form_input = isFormInput
            setCreateCandidateFormInputSuccess(false)
        }

        if (refererInfo) {
            payload.referer_info = {
                referer_id: refererInfo.refererId,
                comment_about_person: refererInfo.commentAboutPerson,
                job_referred: refererInfo.jobReferred
            }
        }

        CandidateService.saveCandidateNewInput(payload)
            .then((res) => {
                if (res.sts_code === ResponseCode.SUCCESS) {
                    toast.success(Messages.saveInfoSuccess)
                    if (isFormInput) {
                        currCandidate.id = res.content.candidate_id
                        // currCandidate.career_summaries = res.content.career_summaries
                        currCandidate.save_success = true
                        setCurrCandidate({...currCandidate})
                        setCreateCandidateFormInputSuccess(true)
                    }
                } else if (res.sts_code === ResponseCode.EXISTS_GREATER_TWO_SAME_CV) {
                    toast.error(Messages.existsTwoOtherPersonsUsePhoneEmail);
                } else if (res.sts_code === ResponseCode.HAVE_DIFF_FIELD_ONE_VALUE) {
                    toast.warning(Messages.otherUserInputDiffValueOfFieldOne);
                    alert(Messages.otherUserInputDiffValueOfFieldOne);
                } else if (res.sts_code === ResponseCode.PHONE_EMAIL_USED_BY_OTHER_USER) {
                    toast.error(res.message);
                    alert(res.message);
                } else {
                    alertMessage(res.sts_code, true, true)
                }

            })
            .catch((error) => {
                // toast.error(`Lưu thông tin thất bại.`);
                console.log(`Error:${JSON.stringify(error)}`);
            });
    };

    const onSaveCareerSummary = async () => {
        onSortCareerSummary()
        await onUpdateExtractResult(currCandidate, ['career_summaries'])
    }

    const onSaveReferCheck = async () => {
        await onUpdateExtractResult(currCandidate, ['refer_checks'])
    }

    const onSaveFlows = async () => {
        const fields = [
            'candidate_know_state',
            'object_special',
            'job_send_request',
            'standard_search_ignore',
            'input_me_list',
            'block_state',
            'candidate_type',
            'flow_note',
        ]

        await onUpdateExtractResult(currCandidate, fields)
    }

    const onSaveCandidateCategories = async () => {
        const fields = [
            'latest_stable_level',
            'highest_level',
            'new_work_level',
            'unknown_level',
        ]
        CANDIDATE_CATEGORY_FIELDS.forEach(item => {
            fields.push(item.key)
        })

        await onUpdateExtractResult(currCandidate, fields)
    }

    const onSaveBasicInfo = async () => {
        const fields = [
            'email_to_send',
            'full_name',
            'last_name',
            'vn_name',
            'foreign_name',
            'email_name',
            'gender',
            'caller_name_to_email',
            'vocative',
            'local_province',
            'local_area',
            'local_province_email',
            'local_area_email',
            'general_note',
            'personal_note'
        ]
        await onUpdateExtractResult(currCandidate, fields)
    }

    const GetInputByAllUsers = async (can) => {
        can.allPersonalInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.Personal)
        can.allLocationsInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.Location)
        can.allContactsInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.Contacts)
        can.allCandidateCategoriesInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.CandidateCategory)
        can.allFlowCategoriesInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.FlowCategory)
        can.allCandidateNotesInfo = await searchAllInputInfo(can.id, CANDIDATE_INPUT_INFO_TYPES.CandidateNotes)
        setCurrCandidate(cloneDeep(can))
        candidates[currentIndex] = cloneDeep(can);
    }

    const onCheckExists = async (candidate) => {
        if (!isFormInput) {
            let confirmMessage = ''
            if (!candidate.email && !candidate.phone) {
                // alert(`Vui lòng nhập email hoặc số điện thoại.`);
                confirmMessage = 'Bạn vẫn muốn tiếp tục dù chưa nhập email và SĐT?'
                // return;
            }

            else if (currCandidate.require_email && !currCandidate.email) {
                // alert(`Vui lòng nhập email.`);
                confirmMessage = 'Có kết quả bóc tách email. Bạn vẫn muốn tiếp tục dù chưa nhập email?'
                // return;
            }

            else if (currCandidate.require_phone && !currCandidate.phone) {
                // alert(`Vui lòng nhập số điện thoại.`);
                confirmMessage = 'Có kết quả bóc tách SĐT. Bạn vẫn muốn tiếp tục dù chưa nhập SĐT?'
                // return;
            }

            if (confirmMessage) {
                if (window.confirm(confirmMessage) === false) {
                    return;
                }
            }
        } else if (!candidate.email && !candidate.phone) {
            currCandidate.checkedExists = true;
            currCandidate.origin_extract_result = {}
            setCurrCandidate({...currCandidate})
            return;
        }

        // Validate email
        if (!validateInputEmail(currCandidate.email)) {
            return;
        }

        // Validate phone
        if (!validateInputPhone(currCandidate.phone)) {
            return;
        }

        // Check standard personal emails. Nếu user xác nhận ok sẽ tiếp tục xử lý tiếp theo.
        const confirm = await CandidateUtils.processWithoutPersonalEmail(stringToArray(currCandidate.email))
        if (!confirm) {
            return;
        }

        setCheckingExistsLoading(true);
        if (refererInfo) {
            currCandidate.referer_info = {
                referer_id: refererInfo.refererId,
                comment_about_person: refererInfo.commentAboutPerson,
                job_referred: refererInfo.jobReferred
            }
        }

        let payload = {candidate_info: currCandidate, extract_type: isFormInput ? ExtractType.INPUT_FORM : ExtractType.UPLOAD_CV}
        CandidateService.checkExists(payload)
            .then((res) => {
                if (res.sts_code === ResponseCode.EXISTS_GREATER_TWO_SAME_CV) {
                    alert("Person trùng với 2 persons khác trên phần mềm.")
                } else if (res.sts_code === ResponseCode.PHONE_EMAIL_USED_BY_OTHER_USER) {
                    alert("Số điện thoại hoặc email đã được sử dụng bởi Person khác.")
                } else {
                    if (res.content.is_input_in_priority) {
                        confirmSubmitNotesWhenInputInPriorityTimeRange(res.content.priority_notify_id)
                    }
                    let canInfo = res.content.candidate_info;
                    canInfo.checkedExists = true;
                    // let canInfo = res.content.candidate_info;
                    // currCandidate.id = canInfo.candidate_id;
                    // currCandidate.db_email = canInfo.email;
                    // currCandidate.db_phone = canInfo.phone;
                    // currCandidate.db_gender = canInfo.gender;
                    // currCandidate.db_local_province = canInfo.local_province;
                    canInfo.already_exists = !!res.content.exists;
                    // Default set email to send as email.
                    // canInfo.email_to_send = currCandidate.email
                    canInfo.needCheckMoreExists = false

                    if (!isFormInput && inputCommonData.hasSaveInputCommon) {
                        saveCommonFields(canInfo, inputCommonData)
                    }

                    if (isFormInput) {
                        canInfo.origin_extract_result = {}
                    }
                    setCurrCandidate({...canInfo})
                    candidates[currentIndex] = cloneDeep(canInfo);
                    GetInputByAllUsers(canInfo)

                    if (onFinishCheckExists) {
                        onFinishCheckExists(canInfo.id)
                    }
                }
            })
            .catch((error) => {
                toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
            })
            .finally(() => {
                setCheckingExistsLoading(false);
            });

    };

    const onReferCheck = async (hasReferCheck) => {
        CandidateService.referCheck({candidate_id: currCandidate.id, has_refer_check: hasReferCheck})
            .then((res) => {
                toast.success(`Lưu thông tin ref check thành công.`);
                candidates[currentIndex].has_refer_check = hasReferCheck;
                currCandidate.has_refer_check = hasReferCheck;
                setCandidates(cloneDeep(candidates));
                // setCurrCandidate(candidates[currentIndex]);
            })
            .catch((error) => {
                // toast.error(`Lưu thông tin ref check thất bại.`);
                // candidates[currentIndex].has_refer_check = true;
                // setCandidates(cloneDeep(candidates));
                // setCurrCandidate(candidates[currentIndex]);
            })
            .finally(() => {
            });

    };

    // Clear value các field chưa thực hiện save.
    const onClearAllFields = (candidate) => {
        if (isFormInput) {
            let cCan = {email: "", local_province: [], local_area:[], local_province_email: [],
                local_area_email:[], latest_stable_level: "", general_note: "", industry_function: [], checkedExists: false}
            setCurrCandidate({...cCan})
        } else {
            if (!candidate.savedFields || candidate.savedFields.length === 0) {
                PROCESS_FIELDS.forEach(field => {
                    candidate[field] = '';
                });
            } else {
                PROCESS_FIELDS.forEach(field => {
                    if (!candidate.savedFields.includes(field)) {
                        candidate[field] = '';
                    }
                });
            }
            setCandidates([...candidates]);
        }
    };

    // Clear value các field chưa thực hiện save.
    const onCareerSummary = (candidate) => {

    };

    // Fill value các field từ kq bóc tách.
    const onFillAllFields = (candidate) => {
        // Get extract result of this candidate
        let extractCandidate = null;
        extractCandidates.forEach(can => {
            if (can.id === candidate.id) {
                extractCandidate = can;
            }
        });
        if (candidate.savedFields && candidate.savedFields.length > 0) {
            PROCESS_FIELDS.forEach(field => {
                if (!candidate.savedFields.includes(field)) {
                    candidate[field] = extractCandidate[field];
                }
            });
        } else {
            PROCESS_FIELDS.forEach(field => {
                candidate[field] = extractCandidate[field];
            });
        }
        setCandidates([...candidates]);
    };

    const diffValueInOptions = (excelValue, fieldType, constArray) => {
        // Mảng lưu value khác với options trong phần mềm
        let diffOptions = []
        constArray = arrayToLowerCase(constArray)
        if (fieldType === 'string') {
            if (excelValue && constArray && constArray.length > 0 && !constArray.includes(excelValue.toLowerCase())) {
                diffOptions.push(excelValue)
            }
        } else if (fieldType === 'array') {
            if (excelValue && excelValue.length > 0 && constArray && constArray.length > 0) {
                if (Array.isArray(excelValue)) {
                    excelValue.forEach(v => {
                        if (!constArray.includes(v.toLowerCase())) {
                            diffOptions.push(v.toLowerCase())
                        }
                    })
                } else if (excelValue && !constArray.includes(excelValue.toLowerCase())) {
                    diffOptions.push(excelValue.toLowerCase())
                }
            }
        } else if (fieldType === 'option') {
            if (excelValue && excelValue.length > 0 && constArray && constArray.length > 0) {
                const arrOptions = optionsToArray(constArray)
                if (Array.isArray(excelValue)) {
                    excelValue.forEach(v => {
                        if (v.value && !arrOptions.includes(v.value.toLowerCase())) {
                            diffOptions.push(v.value.toLowerCase())
                        }
                    })
                } else if (!arrOptions.includes(excelValue.toLowerCase())) {
                    diffOptions.push(excelValue.toLowerCase())
                }
            }
        }

        return diffOptions
    }

    const compareExcelAndDbValues = (excelValue, dbValue, fieldType) => {
        let isEqual = true
        if (fieldType === 'string') {
            isEqual = !excelValue || !dbValue || excelValue.length === 0 || dbValue.length === 0
                || compareString(excelValue, dbValue)
        } else if (fieldType === 'array') {
            isEqual = !excelValue || !dbValue || excelValue.length === 0 || dbValue.length === 0
                || compareArrays(excelValue, dbValue)
        } else if (fieldType === 'option') {
            isEqual = !excelValue || !dbValue || excelValue.length === 0 || dbValue.length === 0
                || compareOptions(excelValue, dbValue)
        }

        return isEqual
    }

    const extractDataValidation = (kqbtValue, dbValue, fieldType, constArray) => {
        if (!currCandidate.already_exists) {
            return "";
        }

        // Check same value and value exists in options
        let isEqual = compareExcelAndDbValues(kqbtValue, dbValue, fieldType)

        // Mảng lưu value khác với options trong phần mềm
        // let diffOptions = diffValueInOptions(excelValue, fieldType, constArray)

        return <>
            {!isEqual &&
            <div className={"w-100"}>
                <span
                    className={"text-danger"}>Khác với giá trị lưu trong phần mềm.</span>
            </div>
            }
            {/*{diffOptions.length > 0 &&*/}
            {/*<div className={"w-100 tex-right"}>*/}
            {/*    <span className={"text-danger"}>Giá trị trong excel không trong danh sách options.</span>*/}
            {/*</div>}*/}
        </>
    }


    return (
        <div className='container-fluid'>
            {candidates.length > 0 && showContent && (
                <div className={isFormInput ? '' : 'card card-default'}>
                    { !isFormInput &&
                    <div className='card-header'>
                        <div className={'row'}>
                            <div className={'col-sm-6'}>
                                <h3 className='card-title col-sm-12'>Kết quả
                                    extract ({currentIndex + 1}/{candidates.length})</h3>
                                {currCandidate && currCandidate.origin_cv &&
                                <h3 className='card-title col-sm-12 mt-1'>{currCandidate.origin_cv.split('/')[2]}</h3>
                                }
                            </div>
                            <div className={'card-tools row'}>
                                {hasInputCommon &&
                                <div className={'text-right'}>
                                    <a className='btn' href='#' data-toggle='modal' data-target='#inputCommonModal'
                                       ref={input => setBtnInputCommonData(input)}>
                                        <i className='fas fa-keyboard'/> Nhập chung
                                    </a>
                                </div>
                                }
                                <div className={'text-right'}>
                                    {currentIndex > 0 ?
                                        <a className='btn' href='#' onClick={onCandidateBack}>
                                            <i className='fas fa-arrow-left'/> Back
                                        </a> :
                                        <button className='btn' disabled type={'button'}>
                                            <i className='fas fa-arrow-left'/> Back
                                        </button>
                                    }
                                </div>
                                <div className={'text-right'}>
                                    {currentIndex < candidates.length - 1 ?
                                        <a className='btn' href='#' onClick={onCandidateNext}>
                                            <i className='fas fa-arrow-right'/> Next
                                        </a> :
                                        <button className='btn' disabled type={'button'}>
                                            <i className='fas fa-arrow-right'/> Next
                                        </button>
                                    }
                                </div>
                                <div className={'text-right float-right'}>
                                    <button className='btn btn-danger' type={'button'}
                                            onClick={() => onRemoveCandidate()}>Xóa UV
                                    </button>
                                </div>
                                {exportExcelFlg &&
                                <>
                                    <div className={'ml-3'}>
                                        <button className='btn btn-primary' type={'button'}
                                                onClick={() => onExportExcel()}>Export excel
                                        </button>
                                    </div>
                                </>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    {currCandidate &&
                    <div className={isFormInput ? '' : 'card-body'}>
                        <div className={'row'}>
                            {!isFormInput &&
                                <div
                                    className='col-sm-6'
                                    style={{maxHeight: '100vh', overflow: 'auto'}}
                                >
                                    {currCandidate &&
                                    <div>
                                        {currCandidate.sensitive_words && currCandidate.sensitive_words.length > 0 &&
                                        <div className="alert alert-warning" role="alert" style={{width: '100%'}}>
                                            <b>CV có chứa từ khóa nhạy cảm: [{arrayToString(currCandidate.sensitive_words)}]</b>
                                        </div>}
                                        {currCandidate.linkedin &&
                                        <a href='#'
                                           onClick={() => openNewTab(`${currCandidate.linkedin}`)}>{`https://${currCandidate.linkedin}`}</a>}
                                        <Document
                                            file={currCandidate.cv_display_url}
                                            onLoadSuccess={pdfInfo => onLoadSuccess(pdfInfo)}
                                        >
                                        {/*    <Document*/}
                                        {/*    file={`blob:http://localhost:3000/34589a57-1b01-4f47-8555-cfc416ef7ad3`}*/}
                                        {/*    onLoadSuccess={pdfInfo => onLoadSuccess(pdfInfo)}*/}
                                        {/*>*/}
                                            {currCandidate.numPages && currCandidate.numPages.map(page =>
                                                (<Page pageNumber={page}
                                                    // width={500} height={800}
                                                       scale={1.5}
                                                />)
                                            )}
                                        </Document>

                                    </div>
                                    }
                                </div>
                            }
                            <div className={isFormInput ? 'col-sm-12' :  'col-sm-6'}
                                 style={{maxHeight: '100vh', overflow: 'auto'}}>
                                <div className='card card-default'>
                                    <div className='card-header'>
                                        {isFormInput &&
                                        <h3 className='card-title'><b>Nhập mẩu thông tin</b></h3>
                                        }
                                        {!exportExcelFlg && currCandidate.checkedExists &&
                                        <div className='card-tools row'>
                                            {!isFormInput &&
                                            <Checkbox
                                                checked={currCandidate.has_refer_check}
                                                onChange={(value) => {
                                                    return onReferCheck(value);
                                                }}
                                                label={'Ref check'}
                                            />
                                            }
                                            {/*<div className="icheck-primary d-inline mr-5">*/}
                                            {/*        <input type='radio' name={`cv-check-item-${index}`}*/}
                                            {/*               style={{opacity: 1, width: 20, height: 20}}*/}
                                            {/*               onClick={event => alert(`Value:${event.target.value}`)}*/}
                                            {/*               className={`cv-check cv-check-item-${index}}`}/>*/}
                                            {/*        */}
                                            {/*</div>*/}
                                            {/*<button type='button' className='btn btn-default mr-2'*/}
                                            {/*        onClick={() => onChangeDisplayCV(item)}>Show CV*/}
                                            {/*</button>*/}
                                            <button type='button' className='btn btn-primary mr-2 ml-3'
                                                    onClick={() => onUpdateExtractResult(currCandidate)}>Save All
                                            </button>
                                            {!isFormInput &&
                                            < button type='button' className='btn btn-success mr-2'
                                                onClick={() => onFillAllFields(currCandidate)}>Fill All
                                                </button>
                                            }
                                            <button type='button' className='btn btn-danger mr-2'
                                                    onClick={() => onClearAllFields(currCandidate)}>Clear All
                                            </button>
                                        </div>
                                        }
                                    </div>
                                    {!exportExcelFlg &&
                                    <div className='card-body'>
                                        {currCandidate.checkedExists && !isFormInput &&
                                        <div className="alert alert-info" role="alert" style={{width: '100%'}}>
                                            {currCandidate.already_exists &&
                                            <b>Person đã tồn tại trên phần mềm với ID: &nbsp;
                                                <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank" rel="noopener noreferrer" >{currCandidate.id}</Link>
                                            </b>
                                            }
                                            {!currCandidate.already_exists &&
                                            <b>Person chưa tồn tại trên phần mềm. Hệ thống đã tự động đăng ký Person này vào phần mềm với ID:&nbsp;
                                                <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank" rel="noopener noreferrer" >{currCandidate.id}</Link>
                                            </b>
                                            }
                                        </div>
                                        }

                                        {isFormInput && (currCandidate.already_exists === true || currCandidate.already_exists === false) &&
                                            <div className="alert alert-info" role="alert" style={{width: '100%'}}>
                                                {currCandidate.already_exists === true &&
                                                <b>Person đã tồn tại trên phần mềm với ID: &nbsp;
                                                    <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank" rel="noopener noreferrer" >{currCandidate.id}</Link>
                                                </b>
                                                }
                                                {currCandidate.already_exists === false &&
                                                <b>Person chưa tồn tại trên phần mềm. Hệ thống đã tự động đăng ký Person này vào phần mềm với ID:&nbsp;
                                                    <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank" rel="noopener noreferrer" >{currCandidate.id}</Link>
                                                </b>
                                                }
                                            </div>
                                        }
                                        {currCandidate.save_success === true &&
                                            <div className="alert alert-info" role="alert" style={{width: '100%'}}>
                                                <b>Person được lưu thành công với ID: &nbsp;
                                                    <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank"
                                                          rel="noopener noreferrer" >{currCandidate.id}</Link>
                                                </b>
                                            </div>
                                        }

                                        {/*{isFormInput && createCandidateFormInputSuccess &&*/}
                                        {/*    <div className="alert alert-info" role="alert" style={{width: '100%'}}>*/}
                                        {/*        <b>Person đã được tạo thành công với ID: &nbsp;*/}
                                        {/*            <Link to={`/candidate/detail/${currCandidate.id}`} target="_blank" rel="noopener noreferrer" >{currCandidate.id}</Link>*/}
                                        {/*        </b>*/}
                                        {/*    </div>*/}
                                        {/*}*/}
                                        <ul className='nav nav-tabs' role='tablist'>
                                            <li className='nav-item'>
                                                <a className='nav-link active' data-toggle='tab' href='#basic'>Thông tin cơ bản</a>
                                            </li>
                                            {currCandidate.checkedExists &&
                                                <>
                                                    <li className='nav-item'>
                                                        <a className='nav-link' data-toggle='tab' href='#career-summary'>Career
                                                            Summary</a>
                                                    </li>
                                                    {!isFormInput &&
                                                    <li className='nav-item'>
                                                        <a className='nav-link' data-toggle='tab' href='#refer-check'>Ref
                                                            Check</a>
                                                    </li>
                                                    }
                                                    <li className='nav-item'>
                                                        <a className='nav-link' data-toggle='tab' href='#categories-tab'>Phân loại, phân luồng</a>
                                                    </li>
                                                    <li className='nav-item'>
                                                        <a className='nav-link' data-toggle='tab' href='#language-tab'>Languages</a>
                                                    </li>
                                                </>
                                            }
                                        </ul>

                                        <div className='tab-content'>
                                            <div id='basic' className='tab-pane active'>
                                                {!currCandidate.checkedExists &&
                                                <>
                                                    <div className='input-group'>
                                                        <label className={'w-100 text-danger'}><b>Email cá nhân</b></label>
                                                        <input type='text' className='form-control'
                                                               value={currCandidate.email}
                                                               required
                                                               onChange={event => {
                                                                   currCandidate.email = event.target.value;
                                                                   setCandidates([...candidates]);
                                                               }} />
                                                        {currCandidate.kqbt_email &&
                                                            <div className={'col-sm-12'}>
                                                                <span
                                                                    className={''}>KQBT: {currCandidate.kqbt_email}</span>
                                                            </div>
                                                        }
                                                        {currCandidate.db_email &&
                                                        <div className={'col-sm-12'}>
                                                        <span
                                                            className={''}>KQPM: {currCandidate.db_email}</span>
                                                        </div>
                                                        }
                                                        <div className={'col-sm-12'}>
                                                            <span className={isFormInput ? 'd-none' : 'input-group-append mt-2'}>
                                                                <button type='button' className='btn btn-warning btn-flat btn-sm'
                                                                        onClick={() => onRemoveSpace('email')}>
                                                                    Xóa blanks
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='input-group mt-3'>
                                                        <label className={'w-100'}>Số điện thoại</label>
                                                        <input type='text' className='form-control'
                                                               value={currCandidate.phone ? currCandidate.phone : ''}
                                                               name={'phone'}
                                                               onChange={event => onChangeInput(event)} />
                                                        {currCandidate.kqbt_phone &&
                                                        <div className={'col-sm-12'}>
                                                            <span
                                                                className={''}>KQBT: {currCandidate.kqbt_phone}</span>
                                                        </div>}
                                                        {currCandidate.db_phone &&
                                                        <div className={'col-sm-12'}>
                                                        <span
                                                            className={''}>KQPM: {currCandidate.db_phone}</span>
                                                        </div>
                                                        }

                                                        <div className={'col-sm-12'}>
                                                        <span className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-warning btn-flat btn-sm'
                                                                    onClick={() => onRemoveSpace('phone')}>
                                                                Xóa blanks
                                                            </button>
                                                        </span>
                                                        </div>
                                                    </div>
                                                    <button type='button' className='btn btn-info btn-flat mt-3'
                                                            disabled={checkingExistsLoading}
                                                            onClick={() => onCheckExists(currCandidate)}>
                                                        {currCandidate.candidate_id ? 'Xác nhận' : 'Check trùng'}
                                                    </button>
                                                </>
                                                }
                                                {currCandidate.checkedExists &&
                                                <>
                                                    <div className='card card-default'>
                                                        <div className='card-header'>
                                                            <h3 className='card-title text-bold'>Thông tin cơ bản</h3>
                                                            <div className='card-tools'>
                                                                <button type='button'
                                                                        className='btn btn-primary'
                                                                        onClick={() => onSaveBasicInfo()}
                                                                        >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className='card-body'>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Email (to send) (BB)</label>
                                                                {checkEmailToSendInErrorBlockEmail()}
                                                                {checkEmailToSendInAllEmail()}
                                                                <input type='text' className='form-control'
                                                                       value={currCandidate.email_to_send ? currCandidate.email_to_send : ''}
                                                                       name={'email_to_send'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                                <button type='button' className='btn btn-info btn-flat'
                                                                        onClick={() => onUpdateExtractResult(currCandidate, ['email_to_send'])}>
                                                                    Save
                                                                </button>
                                                            </span>
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                                <button type='button'
                                                                        className='btn btn-warning btn-flat btn-sm'
                                                                        onClick={() => onRemoveSpace('email_to_send')}>
                                                                    Xóa blanks
                                                                </button>
                                                            </span>
                                                                </div>
                                                                {currCandidate.db_email_to_send &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_email_to_send}</span>
                                                                </div>
                                                                }
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Họ & tên (1) (BB)</label>
                                                                {extractDataValidation(currCandidate.full_name, currCandidate.db_full_name, "string")}
                                                                <input type='text' className='form-control'
                                                                       value={currCandidate.full_name ? currCandidate.full_name : ''}
                                                                       name={'full_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                                <button type='button' className='btn btn-info btn-flat'
                                                                        onClick={() => onUpdateExtractResult(currCandidate, ['full_name'])}>
                                                                    Save
                                                                </button>
                                                            </span>
                                                                {currCandidate.origin_extract_result.full_name &&
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>KQBT: {currCandidate.origin_extract_result.full_name}</span>
                                                                </div>
                                                                }
                                                                {currCandidate.db_full_name &&
                                                                <div className={'w-100'}>
                                                            <span
                                                                className={''}>KQPM: {currCandidate.db_full_name}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='full_name'/>
                                                                <div className={'w-100'}>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                                    <button type='button'
                                                                            className='btn btn-warning btn-flat btn-sm'
                                                                            onClick={() => onRemoveSpace('full_name')}>
                                                                        Xóa blanks
                                                                    </button>
                                                                </span>
                                                                </div>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Họ (1) (BB)</label>
                                                                {extractDataValidation(currCandidate.last_name, currCandidate.db_last_name, "string")}
                                                                <input type='text' className='form-control'
                                                                       value={currCandidate.last_name ? currCandidate.last_name : ''}
                                                                       name={'last_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['last_name'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_last_name &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_last_name}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='last_name'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Tên VN (1) (BB)</label>
                                                                {extractDataValidation(currCandidate.vn_name, currCandidate.db_vn_name, "string")}
                                                                <input type='text' className='form-control'
                                                                       value={currCandidate.vn_name ? currCandidate.vn_name : ''}
                                                                       name={'vn_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['vn_name'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.origin_extract_result.vn_name &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQBT: {currCandidate.origin_extract_result.vn_name}</span>
                                                                </div>
                                                                }
                                                                {currCandidate.db_vn_name &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_vn_name}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='vn_name'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Tên nước ngoài (1) (BB)</label>
                                                                {extractDataValidation(currCandidate.foreign_name, currCandidate.db_foreign_name, "string")}
                                                                <input type='text' className='form-control'
                                                                       value={currCandidate.foreign_name ? currCandidate.foreign_name : ''}
                                                                       name={'foreign_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['foreign_name'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_foreign_name &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_foreign_name}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='foreign_name'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}><b>Tên (Email) (1) (BB)</b></label>
                                                                <input type='text' className='form-control'
                                                                       value={currCandidate.email_name ? currCandidate.email_name : ''}
                                                                       name={'email_name'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['email_name'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_email_name &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_email_name}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='email_name'/>
                                                            </div>
                                                            <DobInputGroup
                                                                showBtnSave
                                                                label={'DOB Giấy tờ'}
                                                                dayName={'paper_dob'}
                                                                monthName={'paper_mob'}
                                                                yearName={'paper_yob'}
                                                                values={currCandidate}
                                                                onChange={event => onChangeInput(event)}
                                                                onSave={event => onUpdateExtractResult(currCandidate, ['paper_dob', 'paper_mob', 'paper_yob'])}
                                                                allInputInfo={currCandidate.allPersonalInfo}
                                                                dbInfo={currCandidate}
                                                                originExtractResult={currCandidate.origin_extract_result}
                                                            />
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Giới tính (BB)</label>
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.gender?currCandidate.gender:''}*/}
                                                                {/*       name={'gender'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                {extractDataValidation(currCandidate.gender, currCandidate.db_gender, "string")}
                                                                <select className='form-control'
                                                                        name={'gender'}
                                                                        value={currCandidate.gender ? currCandidate.gender : ''}
                                                                        onChange={event => onChangeInput(event)}>
                                                                    <option value=''>&nbsp;</option>
                                                                    {GENDERS.map(item => {
                                                                        return <option value={item.toLowerCase()}
                                                                                       key={`gender_${item}`}>{item}</option>
                                                                    })}
                                                                </select>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['gender'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.origin_extract_result.gender &&
                                                                <div className={'col-sm-12'}>
                                                            <span
                                                                className={''}>KQBT: {currCandidate.origin_extract_result.gender}</span>
                                                                </div>
                                                                }
                                                                {currCandidate.db_gender &&
                                                                <div className={'col-sm-12'}>
                                                        <span
                                                            className={''}>KQPM: {currCandidate.db_gender}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='gender'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>Gọi UV là
                                                                    (email) (BB)</label>
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.caller_name_to_email?currCandidate.caller_name_to_email:''}*/}
                                                                {/*       name={'caller_name_to_email'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <select className='form-control'
                                                                        name={'caller_name_to_email'}
                                                                        value={currCandidate.caller_name_to_email ? currCandidate.caller_name_to_email : ''}
                                                                        onChange={event => onChangeInput(event)}>
                                                                    <option value=''>&nbsp;</option>
                                                                    {currCandidate.gender !== 'nữ' &&
                                                                    <option value='anh'>anh</option>
                                                                    }
                                                                    {currCandidate.gender !== 'nam' &&
                                                                    <option value='chị'>chị</option>
                                                                    }
                                                                </select>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['caller_name_to_email'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_caller_name_to_email &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_caller_name_to_email}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='caller_name_to_email'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}>User xưng là (email) (BB)</label>
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.vocative?currCandidate.vocative:''}*/}
                                                                {/*       name={'vocative'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <select className='form-control'
                                                                        name={'vocative'}
                                                                        value={currCandidate.vocative ? currCandidate.vocative : ""}
                                                                        onChange={event => onChangeInput(event)}>
                                                                    {currCandidate.caller_name_to_email === 'anh' || currCandidate.caller_name_to_email === 'chị' ?
                                                                        <option value={stringToLowerCase(userLoginInfo.name)}>
                                                                            {userLoginInfo.name}
                                                                        </option>
                                                                        :
                                                                        <>
                                                                            {/*<option value='anh'>anh</option>*/}
                                                                            <option
                                                                                value={stringToLowerCase(userLoginInfo.name)}>{userLoginInfo.name}</option>
                                                                            <option
                                                                                value={userLoginInfo.vocative}>{userLoginInfo.vocative}</option>
                                                                        </>
                                                                    }
                                                                </select>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['vocative'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_vocative &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_vocative}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='vocative'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Quốc tịch</label>
                                                                <div style={{width: '100%'}}>
                                                                    {extractDataValidation(optionsToArray(currCandidate.local_nationality),
                                                                        stringToArray(currCandidate.db_local_nationality), "array")}
                                                                    <Select options={CANDIDATE_NATIONALITIES} isMulti
                                                                            value={currCandidate.local_nationality}
                                                                            onChange={value => {
                                                                                onChangeLocalNationality(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                                    <button type='button' className='btn btn-info btn-flat'
                                                                            onClick={() => onUpdateExtractResult(currCandidate, ['local_nationality'])}>
                                                                        Save
                                                                    </button>
                                                                </span>
                                                                {currCandidate.origin_extract_result.local_nationality &&
                                                                <div className={'w-100'}>
                                                                <span
                                                                    className={''}>KQBT: {currCandidate.origin_extract_result.local_nationality}</span>
                                                                </div>
                                                                }
                                                                {currCandidate.db_local_nationality &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_local_nationality}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_nationality'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Nước ngoài từng làm việc</label>
                                                                <div style={{width: '100%'}}>
                                                                    {extractDataValidation(optionsToArray(currCandidate.local_ever_work_nationality),
                                                                        stringToArray(currCandidate.db_local_ever_work_nationality), "array")}
                                                                    <Select options={COUNTRIES} isMulti
                                                                            value={currCandidate.local_ever_work_nationality}
                                                                            onChange={value => {
                                                                                onChangeLocalEverWorkNationality(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                                    <button type='button' className='btn btn-info btn-flat'
                                                                            onClick={() => onUpdateExtractResult(currCandidate, ['local_ever_work_nationality'])}>
                                                                        Save
                                                                    </button>
                                                                </span>
                                                                {currCandidate.origin_extract_result.local_ever_work_nationality &&
                                                                <div className={'w-100'}>
                                                                <span
                                                                    className={''}>KQBT: {currCandidate.origin_extract_result.local_ever_work_nationality}</span>
                                                                </div>
                                                                }
                                                                {currCandidate.db_local_ever_work_nationality &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_local_ever_work_nationality}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_ever_work_nationality'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Location (Tỉnh)</label>
                                                                <div style={{width: '100%'}}>
                                                                    {extractDataValidation(optionsToArray(currCandidate.local_province),
                                                                        stringToArray(currCandidate.db_local_province), "array")}
                                                                    <Select options={provinceOptions} isMulti
                                                                            value={currCandidate.local_province}
                                                                            onChange={value => {
                                                                                onChangeLocalProvince(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                                    <button type='button' className='btn btn-info btn-flat'
                                                                            onClick={() => onUpdateExtractResult(currCandidate, ['local_province'])}>
                                                                        Save
                                                                    </button>
                                                                </span>
                                                                {currCandidate.origin_extract_result.local_province &&
                                                                <div className={'w-100'}>
                                                                <span
                                                                    className={''}>KQBT: {currCandidate.origin_extract_result.local_province}</span>
                                                                </div>
                                                                }
                                                                {currCandidate.db_local_province &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_local_province}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_province'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}>Location (Vùng, miền)</label>
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.local_area ? currCandidate.local_area : ''}*/}
                                                                {/*       name={'local_area'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={AREA_OPTIONS} isMulti
                                                                            value={currCandidate.local_area}
                                                                            onChange={value => {
                                                                                onChangeLocalArea(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['local_area'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_local_area &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_local_area}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_area'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}><b>Location Tỉnh
                                                                    (Email) (BB)</b></label>
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.local_province_email?currCandidate.local_province_email:currCandidate.local_province}*/}
                                                                {/*       name={'local_province_email'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={provinceOptions} isMulti
                                                                            value={currCandidate.local_province_email}
                                                                            onChange={value => {
                                                                                onChangeLocalProvinceEmail(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['local_province_email'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_local_province_email &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_local_province_email}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_province_email'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100 text-danger'}><b>Location Miền
                                                                    (Email) (BB)</b></label>
                                                                {/*<input type='text' className='form-control'*/}
                                                                {/*       value={currCandidate.local_area_email ? currCandidate.local_area_email : currCandidate.local_area}*/}
                                                                {/*       name={'local_area_email'}*/}
                                                                {/*       onChange={event => onChangeInput(event)} />*/}
                                                                <div style={{width: '100%'}}>
                                                                    <Select options={AREA_OPTIONS} isMulti
                                                                            value={currCandidate.local_area_email}
                                                                            onChange={value => {
                                                                                onChangeLocalAreaEmail(value);
                                                                            }}
                                                                    />
                                                                </div>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['local_area_email'])}>
                                                                Save
                                                            </button>
                                                        </span>

                                                                {currCandidate.db_local_area_email &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_local_area_email}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allLocationsInfo}
                                                                    field='local_area_email'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>General Note</b></label>
                                                                <input type='text' className='form-control'
                                                                       value={currCandidate.general_note}
                                                                       name={'general_note'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['general_note'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_general_note &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={''}>KQPM: {currCandidate.db_general_note}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allCandidateNotesInfo}
                                                                    field='general_note'/>
                                                            </div>
                                                            <div className='input-group mt-3'>
                                                                <label className={'w-100'}><b>Note Thông tin cá nhân</b></label>
                                                                <input type='text' className='form-control'
                                                                       value={currCandidate.personal_note}
                                                                       name={'personal_note'}
                                                                       onChange={event => onChangeInput(event)}/>
                                                                <span
                                                                    className={isFormInput ? 'd-none' : 'input-group-append'}>
                                                            <button type='button' className='btn btn-info btn-flat'
                                                                    onClick={() => onUpdateExtractResult(currCandidate, ['personal_note'])}>
                                                                Save
                                                            </button>
                                                        </span>
                                                                {currCandidate.db_personal_note &&
                                                                <div className={'w-100'}>
                                                                    <span
                                                                        className={'w-100'}>KQPM: {currCandidate.db_personal_note}</span>
                                                                </div>
                                                                }
                                                                <AllUserInputField
                                                                    arrInfo={currCandidate.allPersonalInfo}
                                                                    field='personal_note'/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                }
                                            </div>
                                            {currCandidate.checkedExists &&
                                                <>
                                                    <div id='career-summary' className='tab-pane fade'>
                                                        <div className='card card-default'>
                                                            <div className='card-header'>
                                                                <h3 className='card-title text-bold'>Danh sách career
                                                                    summary</h3>
                                                                <div className={'card-tools'}>
                                                                    <div className={'text-right'}>
                                                                        <button className='btn btn-primary mr-3'
                                                                                type={'button'}
                                                                                onClick={() => onSaveCareerSummary()}>
                                                                            <i className='fas fa-save'/> Save
                                                                        </button>
                                                                        <button className='btn btn-default mr-3'
                                                                                type={'button'}
                                                                                onClick={() => onSortCareerSummary()}>
                                                                            <i className='fas fa-sync'/> Sắp xếp
                                                                        </button>
                                                                        <button className='btn btn-success mr-3'
                                                                                type={'button'}
                                                                                onClick={() => onAddCareerSummary()}>
                                                                            <i className='fas fa-plus'/> Thêm
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='card-body table-responsive p-0 w-100'>
                                                                <table
                                                                    className='table table-hover table-bordered text-nowrap'
                                                                    style={{
                                                                        maxHeight: '80vh',
                                                                        overflow: 'scroll',
                                                                        minHeight: 300
                                                                    }}
                                                                >
                                                                    <thead>
                                                                    <tr>
                                                                        <th>STT</th>
                                                                        <th>Time bắt đầu</th>
                                                                        <th>Time kết thúc</th>
                                                                        <th className={'text-danger'}>Company (TT
                                                                            gốc) (BB)&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                        <th className={"text-danger"}>Title (BB) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                        <th>Email Công
                                                                            ty  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                        <th>Số ĐT Công
                                                                            ty &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                        <th>Note
                                                                            company&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                        <th>Note of
                                                                            period&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                        <th>Displayed
                                                                            period&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>
                                                                        <th>Hành động</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {currCandidate && currCandidate.career_summaries && currCandidate.career_summaries.length > 0
                                                                    && currCandidate.career_summaries.map((item, index) => (
                                                                        <tr key={`career_summary_${index}`}>
                                                                            <td className={userLoginInfo.id !== item.created_user ? "bg-success" : ""}
                                                                                title={`Người input: ${item.user_input}; Ngày NL mới nhất: ${item.updated_date_time}`}>
                                                                                {index + 1}
                                                                            </td>
                                                                            <td>
                                                                                <div className={'row'}>
                                                                                    <div className={'col-sm-12'}>
                                                                                        <Select options={workYears}
                                                                                                placeholder={'Năm'}
                                                                                                isDisabled={userLoginInfo.id !== item.created_user}
                                                                                                value={item.work_start_year ? item.work_start_year : ''}
                                                                                                onChange={value => {
                                                                                                    onChangeWorkTime(index, value, 'work_start_year');
                                                                                                }}
                                                                                        />
                                                                                    </div>
                                                                                    <div className={'col-sm-12 mt-1'}>
                                                                                        <Select options={workMonths}
                                                                                                isDisabled={userLoginInfo.id !== item.created_user}
                                                                                                placeholder={'Tháng'}
                                                                                                value={item.work_start_month ? item.work_start_month : ''}
                                                                                                onChange={value => {
                                                                                                    onChangeWorkTime(index, value, 'work_start_month');
                                                                                                }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className={'row'}>
                                                                                    <div className={'col-sm-12'}>
                                                                                        <Select options={workYears}
                                                                                                placeholder={'Năm'}
                                                                                                isDisabled={userLoginInfo.id !== item.created_user}
                                                                                                value={item.work_end_year ? item.work_end_year : ''}
                                                                                                onChange={value => {
                                                                                                    onChangeWorkTime(index, value, 'work_end_year');
                                                                                                }}
                                                                                        />
                                                                                    </div>
                                                                                    <div className={'col-sm-12 mt-1'}>
                                                                                        <Select options={workMonths}
                                                                                                placeholder={'Tháng'}
                                                                                                isDisabled={userLoginInfo.id !== item.created_user}
                                                                                                value={item.work_end_month ? item.work_end_month : ''}
                                                                                                onChange={value => {
                                                                                                    onChangeWorkTime(index, value, 'work_end_month');
                                                                                                }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                            <textarea className='form-control'
                                                                                      value={item.origin_company ? item.origin_company : ''}
                                                                                      name={'origin_company'}
                                                                                      disabled={userLoginInfo.id !== item.created_user}
                                                                                      onChange={event => onChangeCareerInput(event, index)}/>
                                                                                <div className={'col-sm-12'}>
                                                                                <span
                                                                                    className={isFormInput ? 'd-none' : 'input-group-append mt-2'}>
                                                                                    <button type='button'
                                                                                            disabled={userLoginInfo.id !== item.created_user}
                                                                                            className='btn btn-warning btn-flat btn-sm'
                                                                                            onClick={() => onRemoveSpace('origin_company', index)}>
                                                                                        Xóa blanks
                                                                                    </button>
                                                                                </span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <input type='text' className='form-control'
                                                                                       value={item.title ? item.title : ''}
                                                                                       name={'title'}
                                                                                       disabled={userLoginInfo.id !== item.created_user}
                                                                                       onChange={event => onChangeCareerInput(event, index)}/>
                                                                                <div className={'col-sm-12'}>
                                                                                <span
                                                                                    className={isFormInput ? 'd-none' : 'input-group-append mt-2'}>
                                                                                    <button type='button'
                                                                                            className='btn btn-warning btn-flat btn-sm'
                                                                                            disabled={userLoginInfo.id !== item.created_user}
                                                                                            onClick={() => onRemoveSpace('title', index)}>
                                                                                        Xóa blanks
                                                                                    </button>
                                                                                </span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <input type='text' className='form-control'
                                                                                       value={item.company_email ? item.company_email : ''}
                                                                                       name={'company_email'}
                                                                                       disabled={userLoginInfo.id !== item.created_user}
                                                                                       onChange={event => onChangeCareerInput(event, index)}/>
                                                                            </td>
                                                                            <td>
                                                                                <input type='text' className='form-control'
                                                                                       value={item.company_phone ? item.company_phone : ''}
                                                                                       name={'company_phone'}
                                                                                       disabled={userLoginInfo.id !== item.created_user}
                                                                                       onChange={event => onChangeCareerInput(event, index)}/>
                                                                            </td>
                                                                            <td>
                                                                            <textarea className='form-control'
                                                                                      value={item.company_note ? item.company_note : ''}
                                                                                      name={'company_note'}
                                                                                      disabled={userLoginInfo.id !== item.created_user}
                                                                                      onChange={event => onChangeCareerInput(event, index)}/>
                                                                            </td>
                                                                            <td>
                                                                            <textarea className='form-control'
                                                                                      value={item.note_of_period ? item.note_of_period : ''}
                                                                                      name={'note_of_period'}
                                                                                      disabled={userLoginInfo.id !== item.created_user}
                                                                                      onChange={event => onChangeCareerInput(event, index)}/>
                                                                            </td>
                                                                            <td>
                                                                                <div className='checkbox'>
                                                                                    <input className='form-control'
                                                                                           type={'radio'}
                                                                                           value={item.displayed_flag}
                                                                                           checked={item.displayed_flag}
                                                                                           name={`displayed_flag`}
                                                                                           disabled={userLoginInfo.id !== item.created_user}
                                                                                           onChange={event => onChangeCareerInput(event, index)}/>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <button className='btn btn-danger' type={"button"}
                                                                                   disabled={userLoginInfo.id !== item.created_user}
                                                                                   onClick={() => onDeleteCareerSummary(index)}>
                                                                                    Xóa
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id='refer-check' className='tab-pane fade'>
                                                        <div className='card card-default'>
                                                            <div className='card-header'>
                                                                <h3 className='card-title text-bold'>Danh sách refer
                                                                    check</h3>
                                                                <div className={'card-tools'}>
                                                                    <div className={'text-right'}>
                                                                        <button className='btn btn-primary mr-3'
                                                                                type={'button'}
                                                                                onClick={() => onSaveReferCheck()}>
                                                                            <i className='fas fa-save'/> Save
                                                                        </button>
                                                                        <button className='btn btn-success mr-3'
                                                                                type={'button'}
                                                                                onClick={() => onAddReferCheck()}>
                                                                            <i className='fas fa-plus'/> Thêm
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='card-body table-responsive p-0 w-100'>
                                                                <table
                                                                    className='table table-hover table-bordered text-nowrap'
                                                                    style={{
                                                                        maxHeight: '80vh',
                                                                        overflow: 'scroll',
                                                                        minHeight: 300
                                                                    }}
                                                                >
                                                                    <thead>
                                                                    <tr>
                                                                        <th>STT</th>
                                                                        <th>Nội dung</th>
                                                                        <th style={{width: '50px'}}>Hành động</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {currCandidate && currCandidate.refer_checks && currCandidate.refer_checks.length > 0
                                                                    && currCandidate.refer_checks.map((item, index) => (
                                                                        <tr key={`refer_check_${index}`}>
                                                                            <td>{index + 1}</td>
                                                                            <td>
                                                                            <textarea className='form-control'
                                                                                      value={item.content}
                                                                                      disabled={currCandidate.refer_checks[index].processed}
                                                                                      name={`item_refer_check_${index}`}
                                                                                      onChange={event => onChangeReferCheckInput(event, index)}/>
                                                                                <div className={'col-sm-12'}>
                                                                                <span
                                                                                    className={isFormInput ? 'd-none' : 'input-group-append mt-2'}>
                                                                                    <button type='button'
                                                                                            className='btn btn-warning btn-flat btn-sm'
                                                                                            onClick={() => onRemoveSpaceReferCheckContent(index)}>
                                                                                        Xóa blanks
                                                                                    </button>
                                                                                </span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    className='btn btn-primary btn-sm mr-3'
                                                                                    type={'button'}
                                                                                    onClick={() => onProcessReferCheck(index)}>
                                                                                    Process
                                                                                </button>
                                                                                <a className='btn btn-sm btn-danger'
                                                                                   href='#'
                                                                                   onClick={() => onDeleteReferCheck(index)}>
                                                                                    Xóa
                                                                                </a>
                                                                            </td>
                                                                        </tr>))
                                                                    }
                                                                    </tbody>
                                                                </table>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id='categories-tab' className='tab-pane fade'>
                                                        <div className='card card-default'>
                                                            <div className='card-header'>
                                                                <h3 className='card-title text-bold'>Phân loại</h3>
                                                                <div className={'card-tools'}>
                                                                    <div className={'text-right'}>
                                                                        <button className='btn btn-primary'
                                                                                type={'button'}
                                                                                onClick={() => onSaveCandidateCategories()}>
                                                                            <i className='fas fa-save'/> Save
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='card-body'>
                                                                {CANDIDATE_CATEGORY_FIELDS.map((field, i) => {
                                                                    let fieldValue = currCandidate[field.key] ? currCandidate[field.key] : []
                                                                    if (field.key === 'industry_function') {
                                                                        return <div className='input-group mt-3'>
                                                                            <label className={'w-100'}><b>Industry Function (Linkedin)</b></label>
                                                                            <div style={{width: '100%'}}>
                                                                                <Select options={INDUSTRY_FUNCTIONS} isMulti
                                                                                        value={currCandidate.industry_function}
                                                                                        onChange={value => {
                                                                                            onChangeIndustryFunctionItem(value, 'industry_function');
                                                                                        }}
                                                                                />
                                                                                <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field='industry_function'/>
                                                                                {/*<div className={'w-100'}>*/}
                                                                                {/*    <span*/}
                                                                                {/*        className={''}>Excel: {optionsToString(currCandidate.extract_result.industry_function)}</span>*/}
                                                                                {/*</div>*/}
                                                                                {/*<div className={'w-100'}>*/}
                                                                                {/*    <span*/}
                                                                                {/*        className={''}>PM: {optionsToString(currCandidate.db_candidate_info.industry_function)}</span>*/}
                                                                                {/*</div>*/}
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    return <div className='input-group mt-3'>
                                                                        <label className={`w-100 ${field.textColor}`}>{field.label}</label>
                                                                        <div style={{width: '100%'}}>
                                                                            <ReactChipInput
                                                                                classes={`class1 class2 w-100`}
                                                                                chips={fieldValue}
                                                                                onSubmit={value => onAddIndustryFunctionItem(value, field.key)}
                                                                                onRemove={index => onRemoveIndustryFunctionItem(index, field.key)}
                                                                            />
                                                                            <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field={field.key}/>
                                                                            {/*<div className={'w-100'}>*/}
                                                                            {/*    <span*/}
                                                                            {/*        className={''}>Excel: {currCandidate.extract_result[field.key]}</span>*/}
                                                                            {/*</div>*/}

                                                                            {/*<div className={'w-100'}>*/}
                                                                            {/*    <span*/}
                                                                            {/*        className={''}>PM: {arrayToString(currCandidate.db_candidate_info[field.key])}</span>*/}
                                                                            {/*</div>*/}
                                                                        </div>
                                                                    </div>
                                                                })}
                                                                <div className='input-group mt-3'>
                                                                    <label className={'w-100'}><b>Latest Stable
                                                                        Level</b></label>
                                                                    <select className={`form-control`}
                                                                            value={currCandidate.latest_stable_level ? currCandidate.latest_stable_level.toLowerCase() : ""}
                                                                            name={'latest_stable_level'}
                                                                            onChange={event => onChangeInput(event)}>
                                                                        {LATEST_STABLE_LEVELS.map((item, index) => {
                                                                            return <option
                                                                                value={item.toLowerCase()}>{item}</option>
                                                                        })}
                                                                    </select>
                                                                    <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field='latest_stable_level'/>
                                                                    {/*<div className={'w-100'}>*/}
                                                                    {/*    <span*/}
                                                                    {/*        className={''}>PM: {currCandidate.db_candidate_info.latest_stable_level}</span>*/}
                                                                    {/*</div>*/}
                                                                </div>
                                                                <div className='input-group mt-3'>
                                                                    <label className={'w-100 text-danger'}><b>Highest Level (BB)</b></label>
                                                                    <select
                                                                        className={`form-control`}
                                                                        value={currCandidate.highest_level ? currCandidate.highest_level.toLowerCase() : ''}
                                                                        name={'highest_level'}
                                                                        onChange={event => onChangeInput(event)}>
                                                                        {LATEST_STABLE_LEVELS.map((item, index) => {
                                                                            return <option
                                                                                value={item.toLowerCase()}>{item}</option>
                                                                        })}
                                                                    </select>
                                                                    <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field='highest_level'/>
                                                                    {/*<div className={'w-100'}>*/}
                                                                    {/*    <span*/}
                                                                    {/*        className={''}>Excel: {currCandidate.extract_result.highest_level}</span>*/}
                                                                    {/*</div>*/}

                                                                    {/*<div className={'w-100'}>*/}
                                                                    {/*    <span*/}
                                                                    {/*        className={''}>PM: {currCandidate.db_candidate_info.highest_level}</span>*/}
                                                                    {/*</div>*/}
                                                                </div>
                                                                <div className='input-group mt-3'>
                                                                    <label className={'w-100'}><b>LEVEL mới làm</b></label>
                                                                    <select className='form-control'
                                                                            name={'new_work_level'}
                                                                            value={currCandidate.new_work_level ? currCandidate.new_work_level.toLowerCase() : ''}
                                                                            onChange={event => onChangeInput(event)}>
                                                                        {LATEST_STABLE_LEVELS.map((item, index) => {
                                                                            return <option
                                                                                value={item.toLowerCase()}>{item}</option>
                                                                        })}
                                                                    </select>
                                                                    <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field='new_work_level'/>
                                                                    {/*    <span className={isFormInput ? 'd-none' : 'input-group-append'}>*/}
                                                                    {/*<button type='button' className='btn btn-info btn-flat'*/}
                                                                    {/*        onClick={() => onUpdateExtractResult(currCandidate, ['new_work_level'])}>*/}
                                                                    {/*    Save*/}
                                                                    {/*</button>*/}
                                                                    {/*</span>*/}
                                                                </div>
                                                                <div className='input-group mt-3'>
                                                                    <label className={'w-100'}><b>LEVEL chưa rõ</b></label>
                                                                    <select className='form-control'
                                                                            name={'unknown_level'}
                                                                            value={currCandidate.unknown_level ? currCandidate.unknown_level.toLowerCase() : ''}
                                                                            onChange={event => onChangeInput(event)}>
                                                                        {LATEST_STABLE_LEVELS.map((item, index) => {
                                                                            return <option
                                                                                value={item.toLowerCase()}>{item}</option>
                                                                        })}
                                                                    </select>
                                                                    <AllUserInputField arrInfo={currCandidate.allCandidateCategoriesInfo} field='unknown_level'/>
                                                                    {/*    <span className={isFormInput ? 'd-none' : 'input-group-append'}>*/}
                                                                    {/*<button type='button' className='btn btn-info btn-flat'*/}
                                                                    {/*        onClick={() => onUpdateExtractResult(currCandidate, ['unknown_level'])}>*/}
                                                                    {/*    Save*/}
                                                                    {/*</button>*/}
                                                                    {/*</span>*/}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <CandidateFlows candidate={currCandidate} onSave={() => onSaveFlows()} changeFlows={(can) => {
                                                            setCurrCandidate({...can})
                                                        }}/>
                                                    </div>
                                                    <div id='language-tab' className='tab-pane fade'>
                                                        <CandidateLanguageComponent
                                                            candidateId={currCandidate.id} mode={CandidateDetailLanguageMode.EXTRACT}
                                                            onChange={(values) => {onChangeLanguages(values)}}
                                                        />
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    }

                                    {/*{exportExcelFlg &&*/}
                                    {/*<div className='card-body'>*/}
                                    {/*    <ul className='nav nav-tabs' role='tablist'>*/}
                                    {/*        <li className='nav-item'>*/}
                                    {/*            <a className='nav-link active' data-toggle='tab' href='#excel-basic'>Thông*/}
                                    {/*                tin cơ bản</a>*/}
                                    {/*        </li>*/}
                                    {/*        <li className='nav-item'>*/}
                                    {/*            <a className='nav-link' data-toggle='tab' href='#excel-career-summary'>Career*/}
                                    {/*                Summary</a>*/}
                                    {/*        </li>*/}
                                    {/*    </ul>*/}
                                    {/*    <div className='tab-content'>*/}
                                    {/*        <div id='excel-basic' className='tab-pane active'>*/}
                                    {/*            <div className='input-group'>*/}
                                    {/*                <label className={'w-100 text-danger'}><b>Email cá nhân</b></label>*/}
                                    {/*                <input type='text' className='form-control'*/}
                                    {/*                       required*/}
                                    {/*                       value={currCandidate.email ? currCandidate.email : ''}*/}
                                    {/*                       name={'email'}*/}
                                    {/*                       onChange={event => onChangeInput(event)} />*/}
                                    {/*                {currCandidate.kqbt_email &&*/}
                                    {/*                <div className={'col-sm-12'}>*/}
                                    {/*                    <span*/}
                                    {/*                        className={''}>KQBT: {currCandidate.kqbt_email}*/}
                                    {/*                    </span>*/}
                                    {/*                </div>}*/}
                                    {/*                {currCandidate.db_email &&*/}
                                    {/*                <div className={'col-sm-12'}>*/}
                                    {/*                    <span*/}
                                    {/*                        className={''}>KQPM: {currCandidate.db_email}</span>*/}
                                    {/*                </div>*/}
                                    {/*                }*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}>Số điện thoại</label>*/}
                                    {/*                <input type='text' className='form-control'*/}
                                    {/*                       value={currCandidate.phone ? currCandidate.phone : ''}*/}
                                    {/*                       name={'phone'}*/}
                                    {/*                       onChange={event => onChangeInput(event)} />*/}
                                    {/*                {currCandidate.kqbt_phone &&*/}
                                    {/*                <div className={'col-sm-12'}>*/}
                                    {/*                    <span*/}
                                    {/*                        className={''}>KQBT: {currCandidate.kqbt_phone}</span>*/}
                                    {/*                </div>}*/}
                                    {/*                {currCandidate.db_phone &&*/}
                                    {/*                <div className={'col-sm-12'}>*/}
                                    {/*                <span*/}
                                    {/*                    className={''}>KQPM: {currCandidate.db_phone}</span>*/}
                                    {/*                </div>*/}
                                    {/*                }*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}>Họ & tên </label>*/}
                                    {/*                <input type='text' className='form-control'*/}
                                    {/*                       value={currCandidate.full_name ? currCandidate.full_name : ''}*/}
                                    {/*                       name={'full_name'}*/}
                                    {/*                       onChange={event => onChangeInput(event)} />*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}>Tên VN</label>*/}
                                    {/*                <input type='text' className='form-control'*/}
                                    {/*                       value={currCandidate.vn_name ? currCandidate.vn_name : ''}*/}
                                    {/*                       name={'vn_name'}*/}
                                    {/*                       onChange={event => onChangeInput(event)} />*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}>Tên nước ngoài</label>*/}
                                    {/*                <input type='text' className='form-control'*/}
                                    {/*                       value={currCandidate.foreign_name ? currCandidate.foreign_name : ''}*/}
                                    {/*                       name={'foreign_name'}*/}
                                    {/*                       onChange={event => onChangeInput(event)} />*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100 text-danger'}><b>Tên (Email)</b></label>*/}
                                    {/*                <input type='text' className='form-control'*/}
                                    {/*                       value={currCandidate.email_name ? currCandidate.email_name : ''}*/}
                                    {/*                       name={'email_name'}*/}
                                    {/*                       onChange={event => onChangeInput(event)} />*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}>Giới tính</label>*/}
                                    {/*                <select className='form-control'*/}
                                    {/*                        name={'gender'}*/}
                                    {/*                        value={currCandidate.gender ? currCandidate.gender : ''}*/}
                                    {/*                        onChange={event => onChangeInput(event)}>*/}
                                    {/*                    <option value=''>&nbsp;</option>*/}
                                    {/*                    <option value='Nam'>Nam</option>*/}
                                    {/*                    <option value='Nữ'>Nữ</option>*/}
                                    {/*                    <option value='Không rõ'>Không rõ</option>*/}
                                    {/*                    <option value='LGBT'>LGBT</option>*/}
                                    {/*                </select>*/}
                                    {/*                {currCandidate.kqbt_gender &&*/}
                                    {/*                <div className={'col-sm-12'}>*/}
                                    {/*                    <span*/}
                                    {/*                        className={''}>KQBT: {currCandidate.kqbt_gender}</span>*/}
                                    {/*                </div>}*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100 text-danger'}>Gọi UV là (email)</label>*/}
                                    {/*                <select className='form-control'*/}
                                    {/*                        name={'caller_name_to_email'}*/}
                                    {/*                        value={currCandidate.caller_name_to_email ? currCandidate.caller_name_to_email : ''}*/}
                                    {/*                        onChange={event => onChangeInput(event)}>*/}
                                    {/*                    <option value=''>&nbsp;</option>*/}
                                    {/*                    {currCandidate.gender !== 'nữ' &&*/}
                                    {/*                    <option value='anh'>anh</option>*/}
                                    {/*                    }*/}
                                    {/*                    {currCandidate.gender !== 'nam' &&*/}
                                    {/*                    <option value='chị'>chị</option>*/}
                                    {/*                    }*/}
                                    {/*                </select>*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}>User xưng là (email)</label>*/}
                                    {/*                <select className='form-control'*/}
                                    {/*                        name={'vocative'}*/}
                                    {/*                        value={currCandidate.vocative ? currCandidate.vocative : ''}*/}
                                    {/*                        onChange={event => onChangeInput(event)}>*/}
                                    {/*                    {currCandidate.caller_name_to_email === 'anh' || currCandidate.caller_name_to_email === 'chị' ?*/}
                                    {/*                        <option value={'Trang'}>*/}
                                    {/*                            Trang*/}
                                    {/*                        </option>*/}
                                    {/*                        :*/}
                                    {/*                        <>*/}
                                    {/*                            <option value=''>&nbsp;</option>*/}
                                    {/*                            <option value='chị'>chị</option>*/}
                                    {/*                        </>*/}
                                    {/*                    }*/}
                                    {/*                </select>*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}>Location (Tỉnh)</label>*/}
                                    {/*                <div className={'w-100'}>*/}
                                    {/*                    <Select options={provinceOptions} isMulti*/}
                                    {/*                            value={currCandidate.local_province}*/}
                                    {/*                            onChange={value => {*/}
                                    {/*                                onChangeLocalProvince(value);*/}
                                    {/*                            }}*/}
                                    {/*                    />*/}
                                    {/*                </div>*/}
                                    {/*                {currCandidate.kqbt_local_province &&*/}
                                    {/*                <div className={'col-sm-12'}>*/}
                                    {/*                    <span*/}
                                    {/*                        className={''}>KQBT: {currCandidate.kqbt_local_province}</span>*/}
                                    {/*                </div>}*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}>Location (Vùng, miền)</label>*/}
                                    {/*                <div style={{width: '100%'}}>*/}
                                    {/*                    <Select options={AREA_OPTIONS} isMulti*/}
                                    {/*                            value={currCandidate.local_area}*/}
                                    {/*                            onChange={value => {*/}
                                    {/*                                onChangeLocalArea(value);*/}
                                    {/*                            }}*/}
                                    {/*                    />*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*            {provinceOptions.length > 0 &&*/}
                                    {/*            <div className='input-group mt-3 w-100'>*/}
                                    {/*                <label className={'w-100 text-danger'}><b>Location Tỉnh (Email)</b></label>*/}
                                    {/*                    <Select options={provinceOptions} isMulti*/}
                                    {/*                            value={currCandidate.local_province_email}*/}
                                    {/*                            onChange={value => {*/}
                                    {/*                                onChangeLocalProvinceEmail(value);*/}
                                    {/*                            }}*/}
                                    {/*                    />*/}
                                    {/*            </div>*/}
                                    {/*            }*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100 text-danger'}><b>Location Miền (Email)</b></label>*/}
                                    {/*                <div style={{width: '100%'}}>*/}
                                    {/*                    <Select options={AREA_OPTIONS} isMulti*/}
                                    {/*                            value={currCandidate.local_area_email}*/}
                                    {/*                            onChange={value => {*/}
                                    {/*                                onChangeLocalAreaEmail(value);*/}
                                    {/*                            }}*/}
                                    {/*                    />*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*            /!*<div className='input-group mt-3'>*!/*/}
                                    {/*            /!*    <label className={'w-100'}><b>Industry</b></label>*!/*/}
                                    {/*            /!*    <input type='text' className='form-control'*!/*/}
                                    {/*            /!*           value={currCandidate.industry}*!/*/}
                                    {/*            /!*           name={'industry'}*!/*/}
                                    {/*            /!*           onChange={event => onChangeInput(event)} />*!/*/}
                                    {/*            /!*</div>*!/*/}
                                    {/*            /!*<div className='input-group mt-3'>*!/*/}
                                    {/*            /!*    <label className={'w-100'}><b>Industry - phân khúc 1</b></label>*!/*/}
                                    {/*            /!*    <input type='text' className='form-control'*!/*/}
                                    {/*            /!*           value={currCandidate.industry_segment1}*!/*/}
                                    {/*            /!*           name={'industry_segment1'}*!/*/}
                                    {/*            /!*           onChange={event => onChangeInput(event)} />*!/*/}
                                    {/*            /!*</div>*!/*/}
                                    {/*            /!*<div className='input-group mt-3'>*!/*/}
                                    {/*            /!*    <label className={'w-100'}><b>Industry - phân khúc 2</b></label>*!/*/}
                                    {/*            /!*    <input type='text' className='form-control'*!/*/}
                                    {/*            /!*           value={currCandidate.industry_segment2}*!/*/}
                                    {/*            /!*           name={'industry_segment2'}*!/*/}
                                    {/*            /!*           onChange={event => onChangeInput(event)} />*!/*/}
                                    {/*            /!*</div>*!/*/}
                                    {/*            /!*<div className='input-group mt-3'>*!/*/}
                                    {/*            /!*    <label className={'w-100'}><b>Function</b></label>*!/*/}
                                    {/*            /!*    <input type='text' className='form-control'*!/*/}
                                    {/*            /!*           value={currCandidate.function}*!/*/}
                                    {/*            /!*           name={'function'}*!/*/}
                                    {/*            /!*           onChange={event => onChangeInput(event)} />*!/*/}
                                    {/*            /!*</div>*!/*/}
                                    {/*            /!*<div className='input-group mt-3'>*!/*/}
                                    {/*            /!*    <label className={'w-100'}><b>Function - phân khúc 1</b></label>*!/*/}
                                    {/*            /!*    <input type='text' className='form-control'*!/*/}
                                    {/*            /!*           value={currCandidate.function_segment1}*!/*/}
                                    {/*            /!*           name={'function_segment1'}*!/*/}
                                    {/*            /!*           onChange={event => onChangeInput(event)} />*!/*/}
                                    {/*            /!*</div>*!/*/}
                                    {/*            /!*<div className='input-group mt-3'>*!/*/}
                                    {/*            /!*    <label className={'w-100'}><b>Function - phân khúc 2</b></label>*!/*/}
                                    {/*            /!*    <input type='text' className='form-control'*!/*/}
                                    {/*            /!*           value={currCandidate.function_segment2}*!/*/}
                                    {/*            /!*           name={'function_segment2'}*!/*/}
                                    {/*            /!*           onChange={event => onChangeInput(event)} />*!/*/}
                                    {/*            /!*</div>*!/*/}
                                    {/*            /!*<div className='input-group mt-3'>*!/*/}
                                    {/*            /!*    <label className={'w-100'}><b>Latest Stable Level</b></label>*!/*/}
                                    {/*            /!*    <select className='form-control'*!/*/}
                                    {/*            /!*            name={'latest_stable_level'}*!/*/}
                                    {/*            /!*            value={currCandidate.latest_stable_level}*!/*/}
                                    {/*            /!*            onChange={event => onChangeInput(event)}>*!/*/}
                                    {/*            /!*        {LATEST_STABLE_LEVELS.map((item ,index) => {*!/*/}
                                    {/*            /!*            return <option value={item.toLowerCase()}>{item}</option>*!/*/}
                                    {/*            /!*        })}*!/*/}
                                    {/*            /!*    </select>*!/*/}
                                    {/*            /!*</div>*!/*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}><b>General Note</b></label>*/}
                                    {/*                <input type='text' className='form-control'*/}
                                    {/*                       value={currCandidate.general_note}*/}
                                    {/*                       name={'general_note'}*/}
                                    {/*                       onChange={event => onChangeInput(event)} />*/}
                                    {/*            </div>*/}
                                    {/*            <div className='input-group mt-3'>*/}
                                    {/*                <label className={'w-100'}><b>Note Thông tin cá nhân</b></label>*/}
                                    {/*                <input type='text' className='form-control'*/}
                                    {/*                       value={currCandidate.personal_note}*/}
                                    {/*                       name={'personal_note'}*/}
                                    {/*                       onChange={event => onChangeInput(event)} />*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*        <div id='excel-career-summary' className='tab-pane fade'>*/}
                                    {/*            <div className='card card-default'>*/}
                                    {/*                <div className='card-header'>*/}
                                    {/*                    <h3 className='card-title text-bold'>Danh sách career*/}
                                    {/*                        summary</h3>*/}
                                    {/*                    <div className={'card-tools'}>*/}
                                    {/*                        <div className={'text-right'}>*/}
                                    {/*                            <button className='btn btn-default mr-3' type={'button'}*/}
                                    {/*                                    onClick={() => onSortCareerSummary()}>*/}
                                    {/*                                <i className='fas fa-sync' /> Sắp xếp*/}
                                    {/*                            </button>*/}
                                    {/*                            <button className='btn btn-primary mr-3' type={'button'}*/}
                                    {/*                                    onClick={() => onAddCareerSummary()}>*/}
                                    {/*                                <i className='fas fa-plus' /> Thêm*/}
                                    {/*                            </button>*/}
                                    {/*                        </div>*/}
                                    {/*                    </div>*/}
                                    {/*                </div>*/}
                                    {/*                <div className='card-body table-responsive p-0 w-100'>*/}
                                    {/*                    <table*/}
                                    {/*                        className='table table-hover table-bordered text-nowrap'*/}
                                    {/*                        style={{*/}
                                    {/*                            maxHeight: '80vh',*/}
                                    {/*                            overflow: 'scroll',*/}
                                    {/*                            minHeight: 300*/}
                                    {/*                        }}*/}
                                    {/*                    >*/}
                                    {/*                        <thead>*/}
                                    {/*                        <tr>*/}
                                    {/*                            <th>STT</th>*/}
                                    {/*                            <th>Time bắt đầu</th>*/}
                                    {/*                            <th>Time kết thúc</th>*/}
                                    {/*                            <th>Company (TT gốc)</th>*/}
                                    {/*                            <th>Title &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</th>*/}
                                    {/*                            <th>Note company</th>*/}
                                    {/*                            <th>Note of period</th>*/}
                                    {/*                            <th>Displayed period</th>*/}
                                    {/*                            <th>Hành động</th>*/}
                                    {/*                        </tr>*/}
                                    {/*                        </thead>*/}
                                    {/*                        <tbody>*/}
                                    {/*                        {currCandidate && currCandidate.career_summaries && currCandidate.career_summaries.length > 0*/}
                                    {/*                        && currCandidate.career_summaries.map((item, index) => (*/}
                                    {/*                            <tr key={`career_summary_${index}`}>*/}
                                    {/*                                <td>{index + 1}</td>*/}
                                    {/*                                <td>*/}
                                    {/*                                    <div className={'row'}>*/}
                                    {/*                                        <div className={'col-sm-12'}>*/}
                                    {/*                                            <Select options={workYears}*/}
                                    {/*                                                    placeholder={'Năm'}*/}
                                    {/*                                                    value={item.work_start_year ? item.work_start_year : ''}*/}
                                    {/*                                                    onChange={value => {*/}
                                    {/*                                                        onChangeWorkTime(index, value, 'work_start_year');*/}
                                    {/*                                                    }}*/}
                                    {/*                                            />*/}
                                    {/*                                        </div>*/}
                                    {/*                                        <div className={'col-sm-12 mt-1'}>*/}
                                    {/*                                            <Select options={workMonths}*/}
                                    {/*                                                    placeholder={'Tháng'}*/}
                                    {/*                                                    value={item.work_start_month ? item.work_start_month : ''}*/}
                                    {/*                                                    onChange={value => {*/}
                                    {/*                                                        onChangeWorkTime(index, value, 'work_start_month');*/}
                                    {/*                                                    }}*/}
                                    {/*                                            />*/}
                                    {/*                                        </div>*/}
                                    {/*                                    </div>*/}
                                    {/*                                </td>*/}
                                    {/*                                <td>*/}
                                    {/*                                    <div className={'row'}>*/}
                                    {/*                                        <div className={'col-sm-12'}>*/}
                                    {/*                                            <Select options={workYears}*/}
                                    {/*                                                    placeholder={'Năm'}*/}
                                    {/*                                                    value={item.work_end_year ? item.work_end_year : ''}*/}
                                    {/*                                                    onChange={value => {*/}
                                    {/*                                                        onChangeWorkTime(index, value, 'work_end_year');*/}
                                    {/*                                                    }}*/}
                                    {/*                                            />*/}
                                    {/*                                        </div>*/}
                                    {/*                                        <div className={'col-sm-12 mt-1'}>*/}
                                    {/*                                            <Select options={workMonths}*/}
                                    {/*                                                    placeholder={'Tháng'}*/}
                                    {/*                                                    value={item.work_end_month ? item.work_end_month : ''}*/}
                                    {/*                                                    onChange={value => {*/}
                                    {/*                                                        onChangeWorkTime(index, value, 'work_end_month');*/}
                                    {/*                                                    }}*/}
                                    {/*                                            />*/}
                                    {/*                                        </div>*/}
                                    {/*                                    </div>*/}
                                    {/*                                </td>*/}
                                    {/*                                <td>*/}
                                    {/*                                    <textarea className='form-control'*/}
                                    {/*                                              value={item.origin_company ? item.origin_company : ''}*/}
                                    {/*                                              name={'origin_company'}*/}
                                    {/*                                              onChange={event => onChangeCareerInput(event, index)} />*/}
                                    {/*                                </td>*/}
                                    {/*                                <td>*/}
                                    {/*                                    <input type='text' className='form-control'*/}
                                    {/*                                           value={item.title ? item.title : ''}*/}
                                    {/*                                           name={'title'}*/}
                                    {/*                                           onChange={event => onChangeCareerInput(event, index)} />*/}
                                    {/*                                </td>*/}
                                    {/*                                <td>*/}
                                    {/*                                    <textarea className='form-control'*/}
                                    {/*                                              value={item.company_note ? item.company_note : ''}*/}
                                    {/*                                              name={'company_note'}*/}
                                    {/*                                              onChange={event => onChangeCareerInput(event, index)} />*/}
                                    {/*                                </td>*/}
                                    {/*                                <td>*/}
                                    {/*                                    <textarea className='form-control'*/}
                                    {/*                                              value={item.note_of_period ? item.note_of_period : ''}*/}
                                    {/*                                              name={'note_of_period'}*/}
                                    {/*                                              onChange={event => onChangeCareerInput(event, index)} />*/}
                                    {/*                                </td>*/}
                                    {/*                                <td>*/}
                                    {/*                                    <div className='checkbox'>*/}
                                    {/*                                        <input className='form-control'*/}
                                    {/*                                               type={'radio'}*/}
                                    {/*                                               value={item.displayed_flag}*/}
                                    {/*                                               checked={item.displayed_flag}*/}
                                    {/*                                               name={`displayed_flag`}*/}
                                    {/*                                               onChange={event => onChangeCareerInput(event, index)} />*/}
                                    {/*                                    </div>*/}
                                    {/*                                </td>*/}
                                    {/*                                <td>*/}
                                    {/*                                    <a className='btn btn-danger' href='#'*/}
                                    {/*                                       onClick={() => onDeleteCareerSummary(index)}>*/}
                                    {/*                                        Xóa*/}
                                    {/*                                    </a>*/}
                                    {/*                                </td>*/}
                                    {/*                            </tr>*/}
                                    {/*                        ))}*/}
                                    {/*                        </tbody>*/}
                                    {/*                    </table>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*}*/}
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    {!isFormInput &&
                    < div className='card-footer'>
                        <div className={'row'}>
                            <div className={'col-sm-6'}>
                                <h3 className='card-title col-sm-12'>Kết quả extract
                                    ({currentIndex + 1}/{candidates.length})</h3>
                                {currCandidate &&
                                <h3 className='card-title col-sm-12 mt-1'>{currCandidate.origin_cv ? currCandidate.origin_cv.split('/')[2] : ''}</h3>
                                }
                            </div>
                            <div className={'card-tools row'}>
                                {!exportExcelFlg && hasInputCommon &&
                                <div className={'text-right'}>
                                    <a className='btn' href='#' data-toggle='modal' data-target='#inputCommonModal'
                                       ref={input => setBtnInputCommonData(input)}>
                                        <i className='fas fa-keyboard'/> Nhập chung
                                    </a>
                                </div>}
                                <div className={'text-right'}>
                                    {currentIndex > 0 ?
                                        <a className='btn' href='#' onClick={onCandidateBack}>
                                            <i className='fas fa-arrow-left'/> Back
                                        </a> :
                                        <button className='btn' disabled type={'button'}>
                                            <i className='fas fa-arrow-left'/> Back
                                        </button>
                                    }
                                </div>
                                <div className={'text-right'}>
                                    {currentIndex < candidates.length - 1 ?
                                        <a className='btn' href='#' onClick={onCandidateNext}>
                                            <i className='fas fa-arrow-right'/> Next
                                        </a> :
                                        <button className='btn' disabled type={'button'}>
                                            <i className='fas fa-arrow-right'/> Next
                                        </button>
                                    }
                                </div>
                                {exportExcelFlg &&
                                <>
                                    <div className={'text-right float-right'}>
                                        <button className='btn btn-danger' type={'button'}
                                                onClick={() => onRemoveCandidate()}>Xóa UV
                                        </button>
                                    </div>
                                    <div className={'ml-3'}>
                                        <button className='btn btn-primary' type={'button'}
                                                onClick={() => onExportExcel()}>Export excel
                                        </button>
                                    </div>
                                </>
                                }
                            </div>
                        </div>
                    </div>
                    }
                </div>
            )}
            {cvFailedList.length > 0 && (
                <div className='card card-default mt-3'>
                    <div className='card-header'>
                        <div className={'row'}>
                            <h3 className='card-title col-sm-6'>Số CV extract thất bại ({cvFailedList.length})</h3>
                        </div>
                        <div className='card-body'>
                            <table
                                className='table table-hover table-bordered text-nowrap'
                            >
                                <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Tên file</th>
                                </tr>
                                </thead>
                                <tbody>
                                {cvFailedList.map((item, index) => {
                                    return <tr>
                                        <td>{index + 1}</td>
                                        <td>{item}</td>
                                    </tr>;
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            <div className='modal fade' id='inputCommonModal'>
                <div className='modal-dialog modal-lg'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h4 className='modal-title'>Nhập chung</h4>
                            <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className='modal-body'>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Quốc tịch</b></label>
                                <div style={{width: '100%'}}>
                                    <Select options={CANDIDATE_NATIONALITIES} isMulti
                                            value={
                                                inputCommonData.common_local_nationality && inputCommonData.common_local_nationality.length > 0 ?
                                                    inputCommonData.common_local_nationality : []}
                                            onChange={values => {
                                                onChangeCommonInput(values, 'common_local_nationality');
                                            }}
                                    />
                                </div>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Industry</b></label>
                                {/*<input type='text' className='form-control'*/}
                                {/*       value={inputCommonData.common_industry}*/}
                                {/*       name={'common_industry'}*/}
                                {/*       onChange={event => onChangeCommonInput(event)} />*/}
                                <ReactChipInput
                                    classes='class1 class2 w-100'
                                    chips={inputCommonData.common_industry ? inputCommonData.common_industry : []}
                                    onSubmit={value => onChangeCommonInput(value, 'common_industry')}
                                    onRemove={index => onRemoveCommonIndustryFunctionItem(index, 'common_industry')}
                                />
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Function</b></label>
                                {/*<input type='text' className='form-control'*/}
                                {/*       value={inputCommonData.common_function}*/}
                                {/*       name={'common_function'}*/}
                                {/*       onChange={event => onChangeCommonInput(event)} />*/}
                                <ReactChipInput
                                    classes='class1 class2 w-100'
                                    chips={inputCommonData.common_function ? inputCommonData.common_function : []}
                                    onSubmit={value => onChangeCommonInput(value, 'common_function')}
                                    onRemove={index => onRemoveCommonIndustryFunctionItem(index, 'common_function')}
                                />
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Industry Function (Linkedin)</b></label>
                                <div style={{width: '100%'}}>
                                    <Select options={INDUSTRY_FUNCTIONS} isMulti
                                            value={inputCommonData.common_industry_function}
                                            onChange={value => {
                                                onChangeCommonInput(value, 'common_industry_function');
                                            }}
                                    />
                                </div>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Nguồn UV</b></label>
                                <Select className='w-100'
                                        name={'common_origin'}
                                        options={CANDIDATE_ORIGINS_OPTIONS}
                                        isMulti
                                        value={inputCommonData.common_origin}
                                        onChange={value => onChangeCommonInput(value, 'common_origin')}>
                                </Select>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Notes (Nguồn UV)</b></label>
                                <input type='text' className='form-control'
                                       value={inputCommonData.common_origin_note}
                                       name={'common_origin_note'}
                                       onChange={event => onChangeCommonInput(event)} />
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>General Note</b></label>
                                <input type='text' className='form-control'
                                       value={inputCommonData.common_general_note}
                                       name={'common_general_note'}
                                       onChange={event => onChangeCommonInput(event)} />
                            </div>
                            {!exportExcelFlg &&
                            <>
                                <div className='input-group mt-3'>
                                    <label className={'w-100 text-warning'}><b>UV lạ/quen</b></label>
                                    <select className='form-control'
                                            name={'candidate_know_state'}
                                            value={inputCommonData.candidate_know_state}
                                            disabled={inputCommonData.candidate_know_state==='4'}
                                            onChange={event => onChangeCommonInput(event)}>
                                        <option value='1'>N/A</option>
                                        <option value='2'>UV lạ</option>
                                        <option value='3'>UV quen chưa giới thiệu GP</option>
                                        <option value='4' disabled={!userLoginInfo.is_superuser}>UV quen đã giới thiệu GP</option>
                                    </select>
                                </div>
                                <div className='input-group mt-3'>
                                    <label className={'w-100'}><b>Đối tượng đặc biệt</b></label>
                                    <div style={{width: '100%'}}>
                                    <Select options={OBJECT_SPECIALS} isMulti
                                            value={inputCommonData.object_special}
                                            onChange={value => {
                                                onChangeCommonInput(value, 'common_object_special');
                                            }}
                                    />
                                    </div>
                                </div>
                                <div className='input-group mt-3'>
                                    <label className={'w-100'}><b>Loại UV khỏi Search tiêu chuẩn</b></label>
                                    <select className='form-control'
                                            name={'standard_search_ignore'}
                                            value={inputCommonData.standard_search_ignore}
                                            onChange={event => onChangeCommonInput(event)}>
                                        {STANDARD_SEARCH_IGNORE_OPTIONS.map(opt => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                </div>
                                {userLoginInfo.is_superuser &&
                                <>
                                    <div className='input-group mt-3'>
                                        <label className={'w-100'}><b>Nhập list ME</b></label>
                                        <select className='form-control'
                                                name={'input_me_list'}
                                                value={inputCommonData.input_me_list}
                                                onChange={event => onChangeCommonInput(event)}>
                                            {ME_LIST_INPUT.map(item => (
                                                <option value={item.value} key={`me-list-input-${item.value}`}>{item.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='input-group mt-3'>
                                        <label className={'w-100'}><b>Block UV</b></label>
                                        <select className='form-control'
                                                name={'block_state'}
                                                value={inputCommonData.block_state}
                                                onChange={event => onChangeCommonInput(event)}>
                                            <option value='1'>Unblock</option>
                                            <option value='2'>Blocked</option>
                                        </select>
                                    </div>
                                </>
                                }
                                <div className='input-group mt-3'>
                                    <label className={'w-100'}><b>Xếp loại UV</b></label>
                                    <select className='form-control'
                                            name={'candidate_type'}
                                            value={inputCommonData.candidate_type}
                                            onChange={event => onChangeCommonInput(event)}>
                                        {PersonTypeOptions.map(item => (
                                            <option value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className='input-group mt-3'>
                                    <label className={'w-100'}><b>Note (Phân luồng)</b></label>
                                    <input type='text' className='form-control'
                                           value={inputCommonData.flow_note}
                                           name={'flow_note'}
                                           onChange={event => onChangeCommonInput(event)} />
                                </div>
                                {/*<div className='input-group mt-3'>*/}
                                {/*    <label className={'w-100'}><b>Hide/Show</b></label>*/}
                                {/*    <select className='form-control'*/}
                                {/*            name={'show_hide_state'}*/}
                                {/*            value={inputCommonData.show_hide_state}*/}
                                {/*            onChange={event => onChangeCommonInput(event)}>*/}
                                {/*        <option value='1'>Show</option>*/}
                                {/*        <option value='2'>Hide loại 1</option>*/}
                                {/*        <option value='3'>Hide loại 2</option>*/}
                                {/*    </select>*/}
                                {/*</div>*/}
                            </>
                            }
                        </div>
                        <div className='modal-footer justify-content-between'>
                            <button type='button' className='btn btn-default' data-dismiss='modal'>Close</button>
                            <button type='button' className='btn btn-primary' data-dismiss='modal'
                                    onClick={() => onSaveCommonData()}>Save changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProcessExtractResult;
